webpackJsonp([1],{

/***/ "/VFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Souvenir_Create_Update_Form_vue__ = __webpack_require__("eHOD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c3415b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Souvenir_Create_Update_Form_vue__ = __webpack_require__("mACx");
function injectStyle (ssrContext) {
  __webpack_require__("KHgw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Souvenir_Create_Update_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c3415b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Souvenir_Create_Update_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/cg2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/d0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Walk_List_View_vue__ = __webpack_require__("yucd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b8e0315_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Walk_List_View_vue__ = __webpack_require__("KsP4");
function injectStyle (ssrContext) {
  __webpack_require__("nSBb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Walk_List_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b8e0315_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Walk_List_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("QOuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0IDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form",attrs:{"id":"sign-in-form"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Sign in")]),_vm._v(" "),_c('el-form',{ref:"signInForm",attrs:{"model":_vm.signInForm,"rules":_vm.rules,"label-position":"left","label-width":"12em"}},[_c('el-form-item',{attrs:{"prop":"username"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Username")]),_vm._v(" "),_c('el-input',{model:{value:(_vm.signInForm.username),callback:function ($$v) {_vm.$set(_vm.signInForm, "username", $$v)},expression:"signInForm.username"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Password")]),_vm._v(" "),_c('el-input',{attrs:{"type":_vm.password.type},model:{value:(_vm.signInForm.password),callback:function ($$v) {_vm.$set(_vm.signInForm, "password", $$v)},expression:"signInForm.password"}},[_c('el-button',{attrs:{"slot":"append","icon":_vm.password.icon},on:{"click":_vm.showPassword},slot:"append"})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"id":"login-button","type":"primary"},on:{"click":function($event){return _vm.ready('signInForm')}}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Sign in")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0YIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form",attrs:{"id":"create-user-form"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Add new user")]),_vm._v(" "),_c('el-form',{ref:"userForm",attrs:{"model":_vm.userForm,"rules":_vm.rules,"status-icon":"","label-position":"left","label-width":"12em"}},[_c('el-form-item',{attrs:{"prop":"username"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Username")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-username"},model:{value:(_vm.userForm.username),callback:function ($$v) {_vm.$set(_vm.userForm, "username", $$v)},expression:"userForm.username"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"email"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Email")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-email","type":"email"},model:{value:(_vm.userForm.email),callback:function ($$v) {_vm.$set(_vm.userForm, "email", $$v)},expression:"userForm.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Password")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-password","type":_vm.password.type},model:{value:(_vm.userForm.password),callback:function ($$v) {_vm.$set(_vm.userForm, "password", $$v)},expression:"userForm.password"}},[_c('el-button',{attrs:{"slot":"append","icon":_vm.password.icon},on:{"click":_vm.showPassword},slot:"append"})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"role"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Role")]),_vm._v(" "),_c('el-select',{attrs:{"id":"input-role","placeholder":""},model:{value:(_vm.userForm.role),callback:function ($$v) {_vm.$set(_vm.userForm, "role", $$v)},expression:"userForm.role"}},_vm._l((['admin', 'TI User']),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"id":"button-create-user","type":"primary"},on:{"click":function($event){return _vm.submitForm('userForm')}}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Create")])]),_vm._v(" "),_c('el-button',{attrs:{"id":"button-reset-user-form","type":"warning"},on:{"click":function($event){return _vm.resetForm('userForm')}}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Reset")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "15zi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Monument_Upload_Form_vue__ = __webpack_require__("gA6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Monument_Detailed_View__ = __webpack_require__("9Yw5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monument-list',
  data: function data() {
    var menuItems = {
      images: 'images',
      map: 'map',
      details: 'details',
      comments: 'comments'
    };
    return {
      points: '{value} ' + this.$gettext('points'),
      menuItems: menuItems,
      activeMenuImagesOrMap: menuItems.images,
      activeMenuDetailsOrComments: menuItems.details,
      isEditVisible: false,
      isPreviewVisible: false,
      monumentId: null,
      monument: null,
      monumentList: [],
      comments: [],
      currentPage: 1,
      pageSize: 10,
      monumentListPage: []
    };
  },
  created: function created() {
    this.getMonumentList();
  },

  components: {
    'monument-upload-form': __WEBPACK_IMPORTED_MODULE_1__Monument_Upload_Form_vue__["a" /* default */],
    'monument-detailed-view': __WEBPACK_IMPORTED_MODULE_2__Monument_Detailed_View__["a" /* default */]
  },
  methods: {
    changePage: function changePage() {
      this.monumentListPage = this.monumentList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    getMonumentUrl: function getMonumentUrl(id) {
      return '/#/monuments/' + id;
    },
    handleSelectImagesOrMap: function handleSelectImagesOrMap(key, keyPath) {
      this.activeMenuImagesOrMap = key;
    },
    handleSelectDetailsOrComments: function handleSelectDetailsOrComments(key, keyPath) {
      this.activeMenuDetailsOrComments = key;
    },
    getMonumentList: function getMonumentList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments?lang=' + this.$language.current,
        withCredentials: true
      }).then(function (response) {
        _this.monumentList = response.data;
        _this.monumentListPage = _this.monumentList.slice((_this.currentPage - 1) * _this.pageSize, _this.currentPage * _this.pageSize);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    getMonument: function getMonument(id, callback) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments/' + id,
        withCredentials: true
      }).then(function (response) {
        _this2.monument = response.data;
        callback(null);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
        callback(error);
      });
    },
    handleClose: function handleClose(done) {
      this.$confirm(this.$gettext('Please update if there were added or removed photo/audio files. Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        done();
      }).catch(function () {});
    },
    closePreview: function closePreview(done) {
      this.activeMenuImagesOrMap = this.menuItems.images;
      this.activeMenuDetailsOrComments = this.menuItems.details;
      done();
    },
    edit: function edit(id) {
      var _this3 = this;

      this.getMonument(id, function (error) {
        if (!error) {
          _this3.isEditVisible = true;
        }
      });
    },
    closeEdit: function closeEdit() {
      this.isEditVisible = false;
      this.getMonumentList();
    },
    remove: function remove(id) {
      var _this4 = this;

      this.$confirm(this.$gettext('Are you sure to delete the monument?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'delete',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments/' + id,
          withCredentials: true
        }).then(function () {
          _this4.$message({
            type: 'success',
            message: _this4.$gettext('Delete has completed')
          });
          _this4.getMonumentList();
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this4.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: _this4.$gettext('Delete has canceled')
        });
      });
    },
    downloadQr: function downloadQr(id, name) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/qr/download-qr?id=' + id,
        withCredentials: true,
        responseType: 'blob'
      }).then(function (response) {
        if (response.status === 200) {
          var fileUrl = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileUrl;
          fileLink.setAttribute('download', name + '-QR.png');
          document.body.appendChild(fileLink);

          fileLink.click();
        } else {
          _this5.$message({
            type: 'error',
            message: _this5.$gettext('Fail in downloading qr')
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this5.$message({
          type: 'error',
          message: _this5.$gettext('Fail in downloading qr')
        });
      });
    },
    preview: function preview(id) {
      this.monumentId = id;
      this.isPreviewVisible = true;
    }
  }
});

/***/ }),

/***/ "1FSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1SuZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_string_to_color__ = __webpack_require__("PVA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_string_to_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_string_to_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comment-newsfeed',
  data: function data() {
    return {
      commentList: [],
      show: true
    };
  },
  created: function created() {
    this.getCommentList();
  },

  methods: {
    getMonumentUrl: function getMonumentUrl(id) {
      return '/#/monuments/' + id;
    },
    getColor: function getColor(string) {
      return '#' + __WEBPACK_IMPORTED_MODULE_1_string_to_color___default.a.generate(string);
    },
    getDateTime: function getDateTime(dateString) {
      var now = new Date();
      var date = new Date(dateString);
      if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
        return date.toTimeString().split(' ')[0];
      } else {
        return dateString.slice(0, 10).replace(/-/g, ' ');
      }
    },
    getCommentList: function getCommentList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/comments',
        withCredentials: true
      }).then(function (response) {
        _this.commentList = response.data;
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    }
  }
});

/***/ }),

/***/ "1yTl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2N92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_View_vue__ = __webpack_require__("LQwd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_string_to_color__ = __webpack_require__("PVA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_string_to_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_string_to_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monument-detailed-view',
  props: ['id', 'preview'],
  data: function data() {
    var style = this.preview ? 'monument-details' : 'list monument-details';
    return {
      points: '{value} ' + this.$gettext('points'),
      style: style,
      monument: null,
      previewImageIndex: 0,
      isImagePreviewVisible: false
    };
  },
  created: function created() {
    var _this = this;

    this.getMonument().then(function (monument) {
      _this.monument = monument;
    }).catch(function () {});
  },

  components: {
    'map-view': __WEBPACK_IMPORTED_MODULE_1__Map_View_vue__["a" /* default */]
  },
  methods: {
    getColor: function getColor(string) {
      return '#' + __WEBPACK_IMPORTED_MODULE_2_string_to_color___default.a.generate(string);
    },
    getDateTime: function getDateTime(dateString) {
      var now = new Date();
      var date = new Date(dateString);
      if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
        return date.toTimeString().split(' ')[0];
      } else {
        return dateString.slice(0, 10).replace(/-/g, ' ');
      }
    },
    renderQrAgain: function renderQrAgain() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/qr/new-qr',
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        data: { id: this.id }
      }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this2.$emit('close-edit');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    getMonument: function getMonument() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments/' + this.id + '?lang=' + this.$language.current,
        withCredentials: true
      }).then(function (response) {
        var tmpMonument = response.data;
        return _this3.getMonumentComments().then(function (comments) {
          tmpMonument.comments = comments;
          return tmpMonument;
        }).catch(function (error) {
          return error;
        });
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this3.$message({
          type: 'error',
          message: msg
        });
        return error;
      });
    },
    getMonumentComments: function getMonumentComments() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments/' + this.id + '/comments',
        withCredentials: true
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this4.$message({
          type: 'error',
          message: msg
        });
        return error;
      });
    }
  }
});

/***/ }),

/***/ "2jB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('i',{staticClass:"loading"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2nxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_Page_vue__ = __webpack_require__("Dyd1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3768fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_Page_vue__ = __webpack_require__("ckXb");
function injectStyle (ssrContext) {
  __webpack_require__("lJHS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3768fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "32ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list",attrs:{"id":"companies-list"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Partner companies")]),_vm._v(" "),_c('div',{staticClass:"create-button-container"},[(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-add-partner-company","type":"primary","icon":"el-icon-plus"},on:{"click":function($event){return _vm.$router.push('/companies/create')}}}):_vm._e()],1),_vm._v(" "),(_vm.companiesList.length > 0)?_c('div',[(_vm.companiesList)?_c('el-table',{attrs:{"id":"companies-table","data":_vm.companiesListPage,"height":"100%"}},[_c('el-table-column',{staticClass:"companies-table-column",scopedSlots:_vm._u([{key:"default",fn:function(companies){return [_c('div',{staticClass:"companies-list-flex-container"},[_c('div',{staticClass:"companies-list-thumbnail"},[_c('img',{attrs:{"src":companies.row.thumbnailName}})]),_vm._v(" "),_c('div',{staticClass:"companies-list-content"},[_c('strong',[_c('translate',[_vm._v("Name")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(companies.row.name)),_c('br'),_vm._v(" "),_c('strong',[_c('translate',[_vm._v("Category")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(companies.row.category)),_c('br'),_vm._v(" "),_c('strong',[_c('translate',[_vm._v("Address")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(companies.row.address)+"\n            ")])])]}}],null,false,2453494918)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(companies){return [(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-edit","icon":"el-icon-edit"},on:{"click":function($event){return _vm.edit(companies.row.id)}}}):_vm._e(),_vm._v(" "),(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-delete","type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(companies.row.id)}}}):_vm._e()]}}],null,false,2146636180)})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.companiesList.length,"current-page":_vm.currentPage,"page-size":_vm.pageSize},on:{"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event},"current-change":_vm.changePage}}),_vm._v(" "),(_vm.$session.exists() && _vm.isEditVisible)?_c('el-dialog',{attrs:{"before-close":_vm.handleClose,"visible":_vm.isEditVisible},on:{"update:visible":function($event){_vm.isEditVisible=$event}}},[_c('companies-upload-form',{attrs:{"loaded-form":_vm.companies,"preview":""},on:{"close-edit":_vm.closeEdit}})],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Wu/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hxE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3kLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_Newsfeed_vue__ = __webpack_require__("1SuZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_863d3256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_Newsfeed_vue__ = __webpack_require__("PJGg");
function injectStyle (ssrContext) {
  __webpack_require__("zYn/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_Newsfeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_863d3256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_Newsfeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5AJL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styleClass},[(!_vm.loadedForm)?_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-new-monument"}},[_vm._v("Add new monument")]):_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-edit-monument"}},[_vm._v("Edit monument")]),_vm._v(" "),_c('el-form',{ref:"monumentForm",attrs:{"model":_vm.monumentForm,"rules":_vm.rules,"label-position":"left","label-width":"12em"}},[_c('el-form-item',{attrs:{"prop":"name"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Name")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","placeholder":_vm.namePlaceholder.hu},on:{"focus":function($event){_vm.showName=true}},model:{value:(_vm.monumentForm.name.hu),callback:function ($$v) {_vm.$set(_vm.monumentForm.name, "hu", $$v)},expression:"monumentForm.name.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showName),expression:"showName"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-en","placeholder":_vm.namePlaceholder.en},model:{value:(_vm.monumentForm.name.en),callback:function ($$v) {_vm.$set(_vm.monumentForm.name, "en", $$v)},expression:"monumentForm.name.en"}}),_c('br'),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-ro","placeholder":_vm.namePlaceholder.ro},model:{value:(_vm.monumentForm.name.ro),callback:function ($$v) {_vm.$set(_vm.monumentForm.name, "ro", $$v)},expression:"monumentForm.name.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"position"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Coordinates")]),_vm._v(" "),_c('map-view',{attrs:{"id":"map-view","position":_vm.monumentForm.position,"is-editable":true},on:{"set-position":_vm.setPosition}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"description"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-desciption","type":"textarea","placeholder":_vm.descPlaceholder.hu},on:{"focus":function($event){_vm.showDesc=true}},model:{value:(_vm.monumentForm.description.hu),callback:function ($$v) {_vm.$set(_vm.monumentForm.description, "hu", $$v)},expression:"monumentForm.description.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDesc),expression:"showDesc"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-desciption-en","type":"textarea","placeholder":_vm.descPlaceholder.en},model:{value:(_vm.monumentForm.description.en),callback:function ($$v) {_vm.$set(_vm.monumentForm.description, "en", $$v)},expression:"monumentForm.description.en"}}),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-desciption-ro","type":"textarea","placeholder":_vm.descPlaceholder.ro},model:{value:(_vm.monumentForm.description.ro),callback:function ($$v) {_vm.$set(_vm.monumentForm.description, "ro", $$v)},expression:"monumentForm.description.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"audio"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Audio")]),_vm._v(" "),_c('audio-uploader',{attrs:{"loaded-audio":_vm.monumentForm.audio.hu,"lang":"hu"},on:{"audio-file-changed":function (event) { _vm.changeAudio(event, 'hu') },"audio-file-removed":function (event) { _vm.removeAudio(event, 'hu') }}}),_vm._v(" "),_c('audio-uploader',{attrs:{"loaded-audio":_vm.monumentForm.audio.en,"lang":"en"},on:{"audio-file-changed":function (event) { _vm.changeAudio(event, 'en') },"audio-file-removed":function (event) { _vm.removeAudio(event, 'en') }}}),_vm._v(" "),_c('audio-uploader',{attrs:{"loaded-audio":_vm.monumentForm.audio.ro,"lang":"ro"},on:{"audio-file-changed":function (event) { _vm.changeAudio(event, 'ro') },"audio-file-removed":function (event) { _vm.removeAudio(event, 'ro') }}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"images"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Images")]),_vm._v(" "),_c('image-uploader',{attrs:{"images":_vm.monumentForm.images},on:{"image-added":_vm.addImage,"image-removed":_vm.removeImage}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"urls","align":"left"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("References")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","icon":"plus","type":"primary"},on:{"click":_vm.addRow}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Add")])]),_vm._v(" "),(_vm.monumentForm.urls.length > 0)?_c('el-table',{attrs:{"data":_vm.monumentForm.urls,"border":"","class-name":"url-component"}},[_c('el-table-column',{attrs:{"label":_vm.url,"align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"prefix-icon":"el-icon-fa-link","placeholder":_vm.$gettext('Please enter the url')},on:{"change":function($event){return _vm.saveRow(scope.$index, _vm.monumentForm.urls, scope.row)}},model:{value:(scope.row),callback:function ($$v) {_vm.$set(scope, "row", $$v)},expression:"scope.row"}},[_c('el-button',{attrs:{"slot":"append","size":"small","icon":"el-icon-close"},on:{"click":function($event){return _vm.deleteRow(scope.$index, _vm.monumentForm.urls)}},slot:"append"})],1)]}}],null,false,2108324361)})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',[(_vm.loadedForm)?_c('el-button',{on:{"click":_vm.cancel}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Cancel")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"id":"button-upload","type":"primary"},on:{"click":function($event){return _vm.submitForm('monumentForm')}}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Update")]):_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Upload")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5T+B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("bh3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6FI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[(_vm.userList.length > 0)?_c('div',{attrs:{"id":"user-list"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Tourinfo users")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.userList,"border":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(user){return [_c('div',{staticClass:"user-list-flex-container"},[_c('div',{staticClass:"user-list-thumbnail"},[_c('img',{staticClass:"user-list-image",attrs:{"src":_vm.avatarUrl(user.row.email)}})]),_vm._v(" "),_c('div',{staticClass:"user-list-content"},[(user.row.email)?_c('p',[_c('strong',[_c('translate',[_vm._v("Email")]),_vm._v(":")],1),_vm._v(" "+_vm._s(user.row.email)+"\n              ")]):_vm._e(),_vm._v(" "),(user.row.phoneNumber)?_c('p',[_c('strong',[_c('translate',[_vm._v("Phone number")]),_vm._v(":")],1),_vm._v(" "+_vm._s(user.row.phoneNumber)+"\n              ")]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_c('translate',[_vm._v("Status")]),_vm._v(":")],1),_vm._v(" \n                "),_c('span',{style:(_vm.activeFontColor(user.row.status))},[_vm._v(_vm._s(user.row.status))])])]),_vm._v(" "),_c('div',{staticClass:"user-list-buttons"},[(user.row.status === 'active' && user.row.username !== _vm.$session.get('username'))?_c('el-button',{staticClass:"ti-user-list-button",attrs:{"type":"danger"},on:{"click":function($event){return _vm.deactivate(user.row.id)}}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Deactivate")])]):_vm._e(),_vm._v(" "),(user.row.status === 'inactive' && user.row.username !== _vm.$session.get('username'))?_c('el-button',{staticClass:"ti-user-list-button",attrs:{"type":"success"},on:{"click":function($event){return _vm.activate(user.row.id)}}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Activate")])]):_vm._e(),_vm._v(" "),(user.row.username !== _vm.$session.get('username'))?_c('el-button',{staticClass:"ti-user-list-button",attrs:{"type":"warning"},on:{"click":function($event){return _vm.resetPassword(user.row.id)}}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Reset password")])]):_vm._e()],1)])]}}],null,false,3937079074)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.username,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(user){return [_vm._v("\n          "+_vm._s(user.row.username)+"\n        ")]}}],null,false,2826797195)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.fullName,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(user){return [_vm._v("\n          "+_vm._s(user.row.firstName)+" "+_vm._s(user.row.lastName)+"\n        ")]}}],null,false,244775163)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.role,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(user){return [_vm._v("\n          "+_vm._s(user.row.role)+"\n        ")]}}],null,false,2225770473)})],1)],1):_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("There are no Tourinfo users...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6GC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('tourguide-navbar'),_vm._v(" "),_c('tourguide-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6TVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sign-in',
  data: function data() {
    return {
      password: {
        visible: false,
        type: 'password',
        icon: 'el-icon-fa-eye'
      },
      signInForm: {
        username: '',
        password: ''
      },
      rules: {
        username: {
          type: 'string',
          required: true,
          message: this.$gettext('Please enter username')
        },
        password: {
          type: 'string',
          required: true,
          message: this.$gettext('Please enter password')
        }
      }
    };
  },

  methods: {
    showPassword: function showPassword() {
      if (!this.password.visible) {
        this.password.type = 'text';
        this.password.icon = 'el-icon-fa-eye-slash';
        this.password.visible = true;
      } else {
        this.password.type = 'password';
        this.password.icon = 'el-icon-fa-eye';
        this.password.visible = false;
      }
    },
    signIn: function signIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/auth/login',
        withCredentials: true,
        auth: {
          username: this.signInForm.username,
          password: this.signInForm.password
        }
      }).then(function (response) {
        _this.$message({
          type: 'success',
          message: _this.$gettext('Signed in')
        });
        _this.$session.set('id', response.data.id);
        _this.$session.set('username', response.data.username);
        _this.$session.set('email', response.data.email);
        _this.$session.set('role', response.data.role);
        _this.$router.push('monuments/list');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          if (error.response.status === 404) {
            msg = _this.$gettext('Wrong username or password');
          } else {
            msg = error.response.statusText;
          }
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    ready: function ready(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.signIn();
        }
      });
    }
  }
});

/***/ }),

/***/ "6VMs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6jlh":
/***/ (function(module, exports) {

module.exports = {"en":{"About Us":"About Us","Activate":"Activate","Add":"Add","Add monument":"Add monument","Add new monument":"Add new monument","Add new souvenir":"Add new souvenir","Add new user":"Add new user","All rights reserved.":"All rights reserved.","Are you sure to close?":"Are you sure to close?","Audio":"Audio","Audio guide not available in the current language":"Audio guide not available in the current language","Cancel":"Cancel","Change password":"Change password","Comments":"Comments","Contacts":"Contacts","Coordinates":"Coordinates","Create":"Create","Create user":"Create user","Created by":"Created by","Deactivate":"Deactivate","Description":"Description","Details":"Details","Edit monument":"Edit monument","Edit souvenir":"Edit souvenir","Edit profile":"Edit profile","Email":"Email","Fellow workers":"Fellow workers","First name":"First name","Fail in downloading qr":"Fail in downloading qr!","Generate qr again":"Generate qr again","Get our android app!":"Get our android app!","Images":"Images","inform tourists about accommodation and restaurants in the city and the surrounding area":"inform tourists about accommodation and restaurants in the city and the surrounding area","Language":"Language","Last name":"Last name","Map":"Map","Monuments":"Monuments","Monuments list":"Monuments list","Name":"Name","office manager":"office manager","Password":"Password","Phone number":"Phone number","Powered by":"Powered by","promotion of timely events":"promotion of timely events","prospectus about the sights of the city":"prospectus about the sights of the city","Rating":"Rating","References":"References","Reported comments":"Reported comments","Reset":"Reset","Reset password":"Reset password","Role":"Role","Sign in":"Sign in","Sign out":"Sign out","Status":"Status","Souvenirs":"Souvenirs","Souvenirs list":"Souvenirs list","The office publishes the Tourism Catalog of Odorheiu Secuiesc and its surroundings every year from 2007. The brochure is published in 10,000 copies in four languages (Hungarian, Romanian, English, German). The catalog contains the brief story of the city, the sights, a city map, useful informations and informations about continuous programs and freetime activities.":"The office publishes the Tourism Catalog of Odorheiu Secuiesc and its surroundings every year from 2007. The brochure is published in 10,000 copies in four languages (Hungarian, Romanian, English, German). The catalog contains the brief story of the city, the sights, a city map, useful informations and informations about continuous programs and freetime activities.","The primary task of the TourInfo Office":"The primary task of the TourInfo Office","The TourInfo Office is in the center of Odorheiu Secuiesc, at Kossuth Lajos street 20 and it is maintained by the City Government.":"The TourInfo Office is in the center of Odorheiu Secuiesc, at Kossuth Lajos street 20 and it is maintained by the City Government.","There are no comments":"There are no comments","There are no monuments":"There are no monuments","There are no Tourinfo users...":"There are no Tourinfo users...","Tourinfo Office":"Tourinfo Office","Tourinfo users":"Tourinfo users","Tourinfo users list":"Tourinfo users list","touristic professional performer":"touristic professional performer","touristic referent":"touristic referent","Update":"Update","Upload":"Upload","Username":"Username","Users":"Users","Upload hungarian audio":"Upload hungarian audio","Upload english audio":"Upload english audio","Upload romanian audio":"Upload romanian audio","Only one file can be uploaded!":"Only one file can be uploaded!","Please sign out and sign in as an admin!":"Please sign out and sign in as an admin user!","Please enter username":"Please enter username","The email is not valid":"The email is not valid","Please enter password":"Please enter password","Length should be min 5 characters":"Length should be min 5 characters","Please select role":"Please select role","Please enter email":"Please enter email","Email already exists in the database":"Email already exists in the database","Username already exists in the database":"Username already exists in the database","points":"points","Please update if there were added or removed photo/audio files. Are you sure to close?":"Please update if there were added or removed photo/audio files. Are you sure to close?","Yes":"Yes","No":"No","Are you sure to delete the monument?":"Are you sure to delete the monument?","Delete has completed":"Delete has completed","Delete has canceled":"Delete has canceled","Url":"Url","Name in Hungarian":"Name in Hungarian","Name in English":"Name in English","Name in Romanian":"Name in Romanian","Description in Hungarian":"Description in Hungarian","Description in English":"Description in English","Description in Romanian":"Description in Romanian","Please add name":"Please add name","Please add description":"Please add description","Max description length is 10000 characters":"Max description length is 10000 characters","Please add images":"Please add images","Url is not valid":"Url is not valid","Please set the coordinates":"Please set the coordinates","Comment deleted successfully!":"Comment deleted successfully!","Signed in":"Signed in","Wrong username or password":"Wrong username or password","Signed out":"Signed out","Full name":"Full name","Please sign out and sign in as an admin user!":"Please sign out and sign in as an admin user!","Are you sure to deactivate the user?":"Are you sure to deactivate the user?","User has deactivated":"User has deactivated","Deactivate has canceled":"Deactivate has canceled","Are you sure to activate the user?":"Are you sure to activate the user?","User has been activated":"User has been activated","Activation was canceled":"Activation was canceled","Are you sure to reset the user's password?":"Are you sure to reset the user's password?","Password has reseted":"Password has reseted","Password reset has canceled":"Password reset has canceled","Price":"Price","Phone number is not valid":"Phone number is not valid","Please enter the price of the item":"Please enter the price of the item in RON","Please enter the price of the item or validate the number":"Please enter the price of the item or validate the number","Update has completed":"Update has completed","Add a new partner company":"Add a new partner company","Address":"Address","Category":"Category","Partner companies":"Partner companies","Partner companies list":"Partner companies list","Select a category":"Select a category","Website":"Website","Are you sure to delete the partner company?":"Are you sure to delete the partner company?","Edit partner company":"Edit partner company","Themed walks list":"Themed walks list","Themed walks":"Themed walks","Add new themed walk":"Add new themed walk","Edit themed walk":"Edit themed walk","Are you sure to delete the themed walk?":"Are you sure to delete the themed walk?","Title":"Title","Subtitle":"Subtitle","Title in Hungarian":"Title in Hungarian","Title in English":"Title in English","Title in Romanian":"Title in Romanian","Subtitle in Hungarian":"Subtitle in Hungarian","Subtitle in English":"Subtitle in English","Subtitle in Romanian":"Subtitle in Romanian","Please choose a category":"Please choose a category","Please add address":"Please add address","Please add title":"Please add title","Please add subtitle":"Please add subtitle","Invalid website URL":"Invalid website URL. It should contain \"http://\" or \"https://\""},"hu":{"About Us":"Rólunk","Activate":"Aktiválás","Add":"Hozzáad","Add monument":"Új nevezetesség hozzáadása","Add new monument":"Új nevezetesség hozzáadása","Add new souvenir":"Új ajándéktárgy hozzáadása","Add new user":"Új felhasználó hozzáadása","All rights reserved.":"Minden jog fenntartva.","Are you sure to close?":"Biztosan be szeretné zárni?","Audio":"Hanganyag","Audio guide not available in the current language":"Nem érhető el hanganyag az aktuális nyelven","Cancel":"Vissza","Change password":"Jelszó megváltoztatása","Comments":"Hozzászólások","Contacts":"Elérhetőségeink","Coordinates":"Koordináták","Create":"Létrehozás","Create user":"Új felhasználó hozzáadása","Created by":"Készítette","Deactivate":"Deaktiválás","Description":"Leírás","Details":"Részletek","Edit monument":"Nevezetesség szerkesztése","Edit souvenir":"Ajándéktárgy szerkesztése","Edit profile":"Profil szerkesztése","Email":"Email","Fail in downloading qr":"QR kód letöltése sikertelen!","Fellow workers":"Munkatársaink","First name":"Keresztnév","Generate qr again":"QR kód újragenerálása","Get our android app!":"Töltsd le az androidos alkalmazásunkat!","Images":"Képek","inform tourists about accommodation and restaurants in the city and the surrounding area":"a turisták tájékoztatása a város és a környék szállás-és vendéglátó helyeiről","Language":"Nyelv","Last name":"Vezetéknév","Map":"Térkép","Monuments":"Nevezetességek","Monuments list":"Nevezetességek listája","Name":"Név","office manager":"irodavezető","Password":"Jelszó","Phone number":"Telefonszám","Powered by":"Működteti","promotion of timely events":"az időszerű rendezvények népszerűsítése","prospectus about the sights of the city":"a város látnivalóinak ismertetése","Rating":"Értékelés","References":"Források","Reported comments":"Jelentett hozzászólások","Reset":"Visszaállítás","Reset password":"Jelszó visszaállítása","Role":"Szerepkör","Sign in":"Bejelentkezés","Sign out":"Kijelentkezés","Status":"Állapot","Souvenirs":"Ajándéktárgyak","Souvenirs list":"Ajándéktárgyak listája","The office publishes the Tourism Catalog of Odorheiu Secuiesc and its surroundings every year from 2007. The brochure is published in 10,000 copies in four languages (Hungarian, Romanian, English, German). The catalog contains the brief story of the city, the sights, a city map, useful informations and informations about continuous programs and freetime activities.":"Az iroda 2007-től minden évben kiadja Székelyudvarhely és környékének Turisztikai katalógusát. A tájékoztató négy nyelven (magyar, román, angol, német), 10.000 példányban jelenik meg.  A katalógusban Székelyudvarhely Megyei Jogú város rövid története, a város nevezetességei, várostérkép, hasznos információk, állandó programok és szabadidős tevékenységekről szóló információk kaptak helyet.","The primary task of the TourInfo Office":"A Tourinfo iroda elsődleges feladata","The TourInfo Office is in the center of Odorheiu Secuiesc, at Kossuth Lajos street 20 and it is maintained by the City Government.":"A székelyudvarhelyi Tourinfo iroda székhelye a város központjában van (a Kossuth Lajos utca 20 szám) fenntartója a Város Önkormányzata.","There are no comments":"Nincsenek hozzászólások","There are no monuments":"Nincsenek nevezetességek","There are no Tourinfo users...":"Nincsenek Tourinfo felhasználók...","Tourinfo Office":"Tourinfo Iroda","Tourinfo users":"Tourinfo felhasználók","Tourinfo users list":"Tourinfo felhasználók","touristic professional performer":"turisztikai szakelőadó","touristic referent":"turisztikai referens","Update":"Frissítés","Upload":"Feltöltés","Username":"Felhasználónév","Users":"Felhasználók","Upload hungarian audio":"Magyar nyelvű hanganyag feltöltése","Upload english audio":"Angol nyelvű hanganyag feltöltése","Upload romanian audio":"Román nyelvű hanganyag feltöltése","Only one file can be uploaded!":"Csak egy fájlt lehet feltölteni!","Please sign out and sign in as an admin!":"Kérlek jelentkezz ki és jelentkezz be adminként!","Please enter username":"Kérem adja meg a felhasználónevet","The email is not valid":"Helytelen email cím","Please enter password":"Kérem adja meg a jelszót","Length should be min 5 characters":"A hossz legalább 5 karakter","Please select role":"Kérem válasszon szerepkört","Please enter email":"Kérem adja meg az email címet","Email already exists in the database":"Az email cím már foglalt","Username already exists in the database":"A felhasználónév már foglalt","points":"pont","Please update if there were added or removed photo/audio files. Are you sure to close?":"Kérem frissítse, ha  hozzáadott vagy törölt hanganyagot/képet. Biztosan bezárja?","Yes":"Igen","No":"Nem","Are you sure to delete the monument?":"Biztosan törli a nevezetességet?","Delete has completed":"Sikeres törlés","Delete has canceled":"Törlés visszavonva","Url":"Link","Name in Hungarian":"Név magyarul","Name in English":"Név angolul","Name in Romanian":"Név románul","Description in Hungarian":"Leírás magyarul","Description in English":"Leírás angolul","Description in Romanian":"Leírás románul","Please add name":"Kérem adja meg a nevet","Please add description":"Kérem adjon hozzá leírást","Max description length is 10000 characters":"A leírás maximális hossza 10000 karakter","Please add images":"Kérem adjon hozzá képeket","Url is not valid":"Helytelen url","Please set the coordinates":"Kérem adja meg a koordinátákat","Comment deleted successfully!":"Hozzászólás sikeresen törölve!","Signed in":"Bejelentkezve","Wrong username or password":"Helytelen felhasználónév vagy jelszó","Signed out":"Kijelentkezve","Full name":"Teljes név","Please sign out and sign in as an admin user!":"Kérlek jelentkezz ki és jelentkezz be adminként!","Are you sure to deactivate the user?":"Biztosan deaktiválja a felhasználót?","User has deactivated":"Felhasználó deaktiválva","Deactivate has canceled":"Deaktiválás visszavonva","Are you sure to activate the user?":"Biztosan aktiválja a felhasználót?","User has been activated":"Felhasználó aktiválva","Activation was canceled":"Aktiválás visszavonva","Are you sure to reset the user's password?":"Biztosan visszaállítja a felhasználó jelszavát?","Password has reseted":"Jelszó visszaállítva","Password reset has canceled":"Jelszó visszaállítás visszavonva","Phone number is not valid":"Helytelen telefonszám","Price":"Ár","Please enter the price of the item":"Kérem adja meg a tárgy árát RON-ban","Please enter the price of the item or validate the number":"Kérem adjon meg egy árat vagy ellenőrizze a mező helyességét","Update has completed":"Sikeres frissítés","Add a new partner company":"Új partnercég hozzáadása","Address":"Cím","Category":"Kategória","Partner companies":"Partner cégek","Partner companies list":"Partnercégek listája","Select a category":"Vállaszon egy kategóriát","Website":"Weboldal","Are you sure to delete the partner company?":"Biztosan törli a partnercéget?","Edit partner company":"Partnercég szerkesztése","Themed walks list":"Tematikus séták listája","Themed walks":"Tematikus séták","Add new themed walk":"Tematikus séta hozzáadása","Edit themed walk":"Tematikus séta szerkesztése","Are you sure to delete the themed walk?":"Biztosan törli a tematikus sétát?","Title":"Cím","Subtitle":"Alcím","Title in Hungarian":"Cím magyarul","Title in English":"Cím angolul","Title in Romanian":"Cím románul","Subtitle in Hungarian":"Alcím magyarul","Subtitle in English":"Alcím angolul","Subtitle in Romanian":"Alcím románul","Please choose a category":"Kérem válasszon kategóriát","Please add address":"Kérem adja meg a címet","Please add title":"Kérem adja meg a címet","Please add subtitle":"Kérem adja meg az alcímet","Invalid website URL":"Érvénytelen weboldal URL. Tartalmaznia kell a \"http://\" vagy \"https://\""},"ro":{"About Us":"Despre noi","Activate":"Activează","Add":"Adăuga","Add monument":"Adăugă un monument nou","Add new monument":"Adăugă un monument nou","Add new souvenir":"Adăugă un suvenir nou","Add new user":"Adăugați un utilizator nou","All rights reserved.":"Toate drepturile rezervate.","Are you sure to close?":"Sunteți sigur că vă închideți?","Audio":"Audio","Audio guide not available in the current language":"Ghidul audio nu este disponibil în limba curentă","Cancel":"Anulare","Change password":"Schimbare parola","Comments":"Comentarii","Contacts":"Contacte","Coordinates":"Coordonate","Create":"Crează","Create user":"Creaza utilizator","Created by":"Încărcat de","Deactivate":"Deactivează","Description":"Descriere","Details":"Detalii","Edit monument":"Editare monument","Edit souvenir":"Editare suvenir","Edit profile":"Editează profilul","Email":"Email","Fail in downloading qr":"Nu a reușit descărcarea qr!","Fellow workers":"Lucrătorii colaboratori","First name":"Prenume","Generate qr again":"Generați din nou codul qr","Get our android app!":"Descărcați aplicația noastră Android!","Images":"Imagini","inform tourists about accommodation and restaurants in the city and the surrounding area":"informează turiștii despre cazare și restaurante din oraș și din împrejurimi","Language":"Language","Last name":"Nume","Map":"Hartă","Monuments":"Monumente","Monuments list":"Lista Monumentelor","Name":"Nume","office manager":"director de birou","Password":"Parola","Phone number":"Număr de telefon","Powered by":"Susținut de","promotion of timely events":"promovarea evenimentelor în timp util","prospectus about the sights of the city":"o descriere a atracțiilor orașului","Rating":"Evaluare","References":"Referințe","Reported comments":"Comentarii raportate","Reset":"Resetare","Reset password":"Reseteaza parola","Role":"Rol","Sign in":"Loghează-te","Sign out":"Deconectați-vă","Status":"Stare","Souvenirs":"Suvenir","Souvenirs list":"Lista suvenirelor","The office publishes the Tourism Catalog of Odorheiu Secuiesc and its surroundings every year from 2007. The brochure is published in 10,000 copies in four languages (Hungarian, Romanian, English, German). The catalog contains the brief story of the city, the sights, a city map, useful informations and informations about continuous programs and freetime activities.":"Oficiul publică Catalog de turism Odorheiu Secuiesc și împrejurimile sale în fiecare an de la 2007. Broșura este publicată în 10.000 de exemplare în patru limbi (maghiară, română, engleză, germană). Catalogul conține povestea scurtă a orașului, atracții orașului, harta orașului, informații utile și informații despre programele și activitățile de timp liber.","The primary task of the TourInfo Office":"Sarcina principală a Oficiului TourInfo","The TourInfo Office is in the center of Odorheiu Secuiesc, at Kossuth Lajos street 20 and it is maintained by the City Government.":"Biroul TourInfo se află în centrul orașului Odorheiu Secuiesc, pe strada Kossuth Lajos 20 și este susținut de guvernul orașului.","There are no comments :(":"Nu există comentarii :(","There are no monuments :(":"Nu există monumente :(","There are no Tourinfo users...":"Nu există utilizatori Tourinfo ...","Tourinfo Office":"Biroul Tourinfo","Tourinfo users":"Utilizatorii Tourinfo","Tourinfo users list":"Utilizatorii Tourinfo","touristic professional performer":"interpret profesionist turistic","touristic referent":"referent turistic","Update":"Actualizare","Upload":"Încărcați","Username":"Numele de utilizator","Users":"Utilizatori","Upload hungarian audio":"Încărcați audio în limba maghiară","Upload english audio":"Încărcați audio în limba română","Upload romanian audio":"Încărcați audio în limba engleză","Only one file can be uploaded!":"Un singur fișier poate fi încărcat!","Please sign out and sign in as an admin!":"Vă rugăm să vă deconectați și să vă conectați ca administrator!","Please enter username":"Introduceți numele de utilizator","The email is not valid":"Email este invalid","Please enter password":"Introduceți parola","Length should be min 5 characters":"Lungimea trebuie să fie de minim 5 caractere","Please select role":"Selectați roluri","Please enter email":"Introduceți un e-mail","Email already exists in the database":"E-mailul există deja","Username already exists in the database":"Numele de utilizator există deja","points":"puncte","Please update if there were added or removed photo/audio files. Are you sure to close?":"Actualizați dacă au fost adăugate sau eliminate fișiere foto / audio. Sunteți sigur că vă închideți?","Yes":"Da","No":"Nu","Are you sure to delete the monument?":"Sigur ștergeți monumentul?","Delete has completed":"Ștergerea a reușit","Delete has canceled":"Ștergerea a fost anulată","Url":"Adresa URL","Name in Hungarian":"Numele în limba maghiară","Name in English":"Numele în limba engleză","Name in Romanian":"Numele în limba română","Description in Hungarian":"Descriere în limba maghiară","Description in English":"Descriere în limba engleză","Description in Romanian":"Descriere în limba română","Please add name":"Vă rugăm să adăugați un nume","Please add description":"Vă rugăm să adăugați o descriere","Max description length is 10000 characters":"Lungimea descrierii maxime este de 10000 de caractere","Please add images":"Vă rugăm să adăugați imagini","Url is not valid":"Url este invalid","Please set the coordinates":"Vă rugăm să setați coordonatele","Comment deleted successfully!":"Comentariul a fost șters cu succes!","Signed in":"Conectat","Wrong username or password":"Nume utilizator sau parolă greșită","Signed out":"Au fost deconectați","Full name":"Numele complet","Please sign out and sign in as an admin user!":"Vă rugăm să vă deconectați și să vă conectați ca administrator!","Are you sure to deactivate the user?":"Sunteți sigur că dezactivați utilizatorul?","User has deactivated":"Utilizatorul a fost dezactivat","Deactivate has canceled":"Dezactivarea a fost anulată","Are you sure to activate the user?":"Sunteți sigur că activați utilizatorul?","User has been activated":"Utilizatorul a fost activat","Activation was canceled":"Activarea a fost anulată","Are you sure to reset the user's password?":"Sunteți sigur că resetați parola utilizatorului?","Password has reseted":"Parola a fost resetată","Password reset has canceled":"Resetarea parolei a fost anulată","Phone number is not valid":"Numărul de telefon este invalid","Please enter the price of the item":"Introduceți prețul articolului în RON","Please enter the price of the item or validate the number":"Introduceți prețul articolului sau validați numărul","Price":"Preț","Update has completed":"Actualizarea a reușit","Add a new partner company":"Adăugați o companie parteneră nouă","Address":"Adresa","Category":"Categorie","Partner companies":"Companii partenere","Partner companies list":"Lista companiilor partenere","Select a category":"Selectați o categorie","Website":"Website","Are you sure to delete the partner company?":"Sigur ștergeți compania parteneră?","Edit partner company":"Editați compania parteneră","Themed walks list":"Lista plimbărilor tematice","Themed walks":"Plimbări tematice","Add new themed walk":"Adăugă o plimbare tematică","Edit themed walk":"Editare plimbarea tematică ","Are you sure to delete the themed walk?":"Sigur ștergeți plimbarea tematică?","Title":"Titlu","Subtitle":"Subtitlu","Title in Hungarian":"Titlu în limba maghiară","Title in English":"Titlu în limba engleză","Title in Romanian":"Titlu în limba română","Subtitle in Hungarian":"Subtitlu în limba maghiară","Subtitle in English":"Subtitlu în limba engleză","Subtitle in Romanian":"Subtitlu în limba română","Please choose a category":"Vă rugăm alegeți o categorie","Please add address":"Vă rugăm să adăugați adresa","Please add title":"Vă rugăm să adăugați titlu","Please add subtitle":"Vă rugăm să adăugați subtitlu","Invalid website URL":"URL-ul site-ului este invalid. Trebuie să conțină \"http://\" sau \"https://\""}}

/***/ }),

/***/ "72Yd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-container"}},[(_vm.isEditable)?_c('div',{attrs:{"id":"floating-panel"}},[_c('gmap-autocomplete',{attrs:{"id":"search"},on:{"place_changed":_vm.usePlace}})],1):_vm._e(),_vm._v(" "),_c('gmap-map',{attrs:{"center":_vm.center,"zoom":13,"id":"map"},on:{"click":_vm.setPosition}},[(_vm.pos.lat !== null && _vm.pos.lng !== null)?_c('gmap-marker',{attrs:{"position":_vm.pos,"clickable":true,"draggable":_vm.isEditable},on:{"click":function($event){_vm.center=_vm.pos},"drag":_vm.setPosition}}):_vm._e()],1),_vm._v(" "),(_vm.pos.lat !== null && _vm.pos.lng !== null && _vm.isEditable)?_c('el-input',{attrs:{"value":_vm.posText,"readonly":true}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Riu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ffc1da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_Us_vue__ = __webpack_require__("IniZ");
function injectStyle (ssrContext) {
  __webpack_require__("CKBz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ffc1da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_Us_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7l1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Audio_Uploader_vue__ = __webpack_require__("OBxk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image_Uploader_vue__ = __webpack_require__("9fne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Map_View_vue__ = __webpack_require__("LQwd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monument-upload-form',
  components: {
    'audio-uploader': __WEBPACK_IMPORTED_MODULE_0__Audio_Uploader_vue__["a" /* default */],
    'image-uploader': __WEBPACK_IMPORTED_MODULE_2__Image_Uploader_vue__["a" /* default */],
    'map-view': __WEBPACK_IMPORTED_MODULE_3__Map_View_vue__["a" /* default */]
  },
  props: ['loaded-form'],
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$session.exists()) {
        next();
      } else {
        next('/signin');
      }
    });
  },
  data: function data() {
    var styleClass = this.loadedForm ? 'update-form' : 'form';
    var monumentForm = this.loadedForm || {
      name: {
        hu: '',
        en: '',
        ro: ''
      },
      description: {
        hu: '',
        en: '',
        ro: ''
      },
      audio: {
        hu: null,
        en: null,
        ro: null
      },
      position: {
        lat: null,
        lng: null
      },
      urls: [],
      images: []
    };
    monumentForm.removedAudios = [];
    monumentForm.removedImages = [];
    monumentForm.newImages = [];
    monumentForm.removedUrls = [];
    monumentForm.newUrls = [];
    monumentForm.oldUrls = [].concat(monumentForm.urls);
    return {
      url: this.$gettext('Url'),
      namePlaceholder: {
        hu: this.$gettext('Name in Hungarian'),
        en: this.$gettext('Name in English'),
        ro: this.$gettext('Name in Romanian')
      },
      descPlaceholder: {
        hu: this.$gettext('Description in Hungarian'),
        en: this.$gettext('Description in English'),
        ro: this.$gettext('Description in Romanian')
      },
      styleClass: styleClass,
      showName: false,
      showDesc: false,
      monumentForm: monumentForm,
      rules: {
        name: {
          type: 'object',
          required: true,
          fields: {
            hu: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') },
            en: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') },
            ro: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') }
          }
        },
        description: {
          type: 'object',
          required: true,
          fields: {
            hu: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            en: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            ro: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }]
          }
        },
        audio: {
          type: 'object',
          required: false
        },
        images: {
          type: 'array',
          required: true,
          message: this.$gettext('Please add images')
        },
        urls: {
          type: 'array',
          required: false,
          defaultField: { type: 'url', message: this.$gettext('Url is not valid') }
        },
        position: {
          type: 'object',
          required: true,
          message: this.$gettext('Please set the coordinates'),
          trigger: 'change',
          fields: {
            lat: { type: 'float', required: true, message: this.$gettext('Please set the coordinates') },
            lng: { type: 'float', required: true, message: this.$gettext('Please set the coordinates') }
          }
        }
      }
    };
  },

  methods: {
    substract: function substract(a, b) {
      return a.filter(function (element) {
        return b.indexOf(element) < 0;
      });
    },
    setPosition: function setPosition(position) {
      this.monumentForm.position = position;
    },
    uploadForm: function uploadForm() {
      var _this = this;

      this.monumentForm.newUrls = this.monumentForm.urls;
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments',
        headers: { 'Content-Type': 'application/json' },
        data: this.monumentForm,
        withCredentials: true
      }).then(function (response) {
        _this.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this.$router.push('/monuments/list');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    updateForm: function updateForm() {
      var _this2 = this;

      this.monumentForm.newUrls = this.substract(this.monumentForm.urls, this.monumentForm.oldUrls);
      this.monumentForm.removedUrls = this.substract(this.monumentForm.oldUrls, this.monumentForm.urls);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'put',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/monuments/' + this.monumentForm.id,
        headers: { 'Content-Type': 'application/json' },
        data: this.monumentForm,
        withCredentials: true
      }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this2.$emit('close-edit');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    cancel: function cancel() {
      var _this3 = this;

      this.$confirm(this.$gettext('Please update if there were added or removed photo/audio files. Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        _this3.$emit('close-edit');
      }).catch(function () {});
    },
    addRow: function addRow() {
      this.monumentForm.urls.push('');
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    saveRow: function saveRow(index, rows, row) {
      rows.splice(index, 1, row);
    },
    changeAudio: function changeAudio(audioFileName, lang) {
      this.monumentForm.audio[lang] = audioFileName;
    },
    removeAudio: function removeAudio(audioFileName, lang) {
      this.monumentForm.removedAudios.push(audioFileName);
      this.monumentForm.audio[lang] = null;
    },
    addImage: function addImage(imageFileName) {
      this.monumentForm.newImages.push(imageFileName);
    },
    removeImage: function removeImage(imageFileName) {
      this.monumentForm.removedImages.push(imageFileName);
      this.monumentForm.images.splice(this.monumentForm.images.indexOf(imageFileName), 1);
      this.monumentForm.newImages.splice(this.monumentForm.newImages.indexOf(imageFileName), 1);
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;

      if (this.monumentForm.images.length === 0) {
        this.monumentForm.images = [].concat(this.monumentForm.newImages);
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this4.loadedForm) {
            _this4.updateForm();
          } else {
            _this4.uploadForm();
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "7oaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-user-form',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.$session.exists()) {
        if (vm.$session.get('role') === 'admin') {
          next();
        } else {
          _this.$message({
            type: 'warning',
            message: _this.$gettext('Please sign out and sign in as an admin!')
          });
          next('/');
        }
      } else {
        next('/signin');
      }
    });
  },
  data: function data() {
    return {
      validEmail: false,
      validUsername: false,
      password: {
        visible: false,
        type: 'password',
        icon: 'el-icon-fa-eye'
      },
      userForm: {
        username: '',
        email: '',
        password: '',
        role: ''
      },
      rules: {
        username: [{
          type: 'string',
          required: true,
          trigger: 'blur',
          message: this.$gettext('Please enter username')
        }, {
          validator: this.validateUsername,
          trigger: 'blur'
        }],
        email: [{
          type: 'email',
          required: true,
          trigger: 'blur',
          message: this.$gettext('The email is not valid')
        }, {
          validator: this.validateEmail,
          trigger: 'blur'
        }],
        password: [{
          type: 'string',
          required: true,
          trigger: 'blur',
          message: this.$gettext('Please enter password')
        }, {
          min: 5,
          message: this.$gettext('Length should be min 5 characters'),
          trigger: 'blur'
        }],
        role: {
          type: 'string',
          required: true,
          message: this.$gettext('Please select role')
        }
      }
    };
  },

  methods: {
    showPassword: function showPassword() {
      if (!this.password.visible) {
        this.password.type = 'text';
        this.password.icon = 'el-icon-fa-eye-slash';
        this.password.visible = true;
      } else {
        this.password.type = 'password';
        this.password.icon = 'el-icon-fa-eye';
        this.password.visible = false;
      }
    },
    uploadForm: function uploadForm() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users',
        headers: { 'Content-Type': 'application/json' },
        data: this.userForm,
        withCredentials: true
      }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: response.data || 'Upload has completed'
        });
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.uploadForm();
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    validateEmail: function validateEmail(rule, value, callback) {
      var _this4 = this;

      if (value === '') {
        callback(new Error(this.$gettext('Please enter email')));
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'get',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/email/' + this.userForm.email
        }).then(function (response) {
          if (response.data.exist) {
            callback(new Error(_this4.$gettext('Email already exists in the database')));
          } else {
            callback();
          }
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          callback(new Error(msg));
        });
      }
    },
    validateUsername: function validateUsername(rule, value, callback) {
      var _this5 = this;

      if (value === '') {
        callback(new Error(this.$gettext('Please enter username')));
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'get',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/username/' + this.userForm.username
        }).then(function (response) {
          if (response.data.exist) {
            callback(new Error(_this5.$gettext('Username already exists in the database')));
          } else {
            callback();
          }
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          callback(new Error(msg));
        });
      }
    }
  }
});

/***/ }),

/***/ "8gir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styleClass},[(!_vm.loadedForm)?_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-new-walk"}},[_vm._v("Add new themed walk")]):_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-edit-walk"}},[_vm._v("Edit themed walk")]),_vm._v(" "),_c('el-form',{ref:"walkForm",attrs:{"model":_vm.walkForm,"rules":_vm.rules,"label-position":"left","label-width":"12em"}},[_c('el-form-item',{attrs:{"prop":"title"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Title")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-title","placeholder":_vm.titlePlaceholder.hu},on:{"focus":function($event){_vm.showName=true}},model:{value:(_vm.walkForm.title.hu),callback:function ($$v) {_vm.$set(_vm.walkForm.title, "hu", $$v)},expression:"walkForm.title.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showName),expression:"showName"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-title-en","placeholder":_vm.titlePlaceholder.en},model:{value:(_vm.walkForm.title.en),callback:function ($$v) {_vm.$set(_vm.walkForm.title, "en", $$v)},expression:"walkForm.title.en"}}),_c('br'),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-title-ro","placeholder":_vm.titlePlaceholder.ro},model:{value:(_vm.walkForm.title.ro),callback:function ($$v) {_vm.$set(_vm.walkForm.title, "ro", $$v)},expression:"walkForm.title.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"subtitle"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Subtitle")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-subtitle","placeholder":_vm.subtitlePlaceholder.hu},on:{"focus":function($event){_vm.showName=true}},model:{value:(_vm.walkForm.subtitle.hu),callback:function ($$v) {_vm.$set(_vm.walkForm.subtitle, "hu", $$v)},expression:"walkForm.subtitle.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showName),expression:"showName"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-subtitle-en","placeholder":_vm.subtitlePlaceholder.en},model:{value:(_vm.walkForm.subtitle.en),callback:function ($$v) {_vm.$set(_vm.walkForm.subtitle, "en", $$v)},expression:"walkForm.subtitle.en"}}),_c('br'),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-subtitle-ro","placeholder":_vm.subtitlePlaceholder.ro},model:{value:(_vm.walkForm.subtitle.ro),callback:function ($$v) {_vm.$set(_vm.walkForm.subtitle, "ro", $$v)},expression:"walkForm.subtitle.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"description"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-desciption","type":"textarea","placeholder":_vm.descPlaceholder.hu},on:{"focus":function($event){_vm.showDesc=true}},model:{value:(_vm.walkForm.description.hu),callback:function ($$v) {_vm.$set(_vm.walkForm.description, "hu", $$v)},expression:"walkForm.description.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDesc),expression:"showDesc"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-desciption-en","type":"textarea","placeholder":_vm.descPlaceholder.en},model:{value:(_vm.walkForm.description.en),callback:function ($$v) {_vm.$set(_vm.walkForm.description, "en", $$v)},expression:"walkForm.description.en"}}),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-desciption-ro","type":"textarea","placeholder":_vm.descPlaceholder.ro},model:{value:(_vm.walkForm.description.ro),callback:function ($$v) {_vm.$set(_vm.walkForm.description, "ro", $$v)},expression:"walkForm.description.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"images"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Images")]),_vm._v(" "),_c('image-uploader',{attrs:{"images":_vm.walkForm.images},on:{"image-added":_vm.addImage,"image-removed":_vm.removeImage}})],1),_vm._v(" "),_c('el-form-item',[(_vm.loadedForm)?_c('el-button',{on:{"click":_vm.cancel}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Cancel")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"id":"button-upload","type":"primary"},on:{"click":function($event){return _vm.submitForm('walkForm')}}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Update")]):_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Upload")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Yw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monument_Detailed_View_vue__ = __webpack_require__("2N92");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9e9202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monument_Detailed_View_vue__ = __webpack_require__("nxN4");
function injectStyle (ssrContext) {
  __webpack_require__("sBna")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monument_Detailed_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9e9202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monument_Detailed_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9fne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Image_Uploader_vue__ = __webpack_require__("Z+cW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906b9c60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Image_Uploader_vue__ = __webpack_require__("kOa9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Image_Uploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906b9c60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Image_Uploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AAmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Walk_Upload_Form_vue__ = __webpack_require__("EonZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f76a5c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Walk_Upload_Form_vue__ = __webpack_require__("8gir");
function injectStyle (ssrContext) {
  __webpack_require__("5T+B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Walk_Upload_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f76a5c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Walk_Upload_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AseP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BsbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"id":"always-on-top","background-color":"#545c64","text-color":"#fff","active-text-color":"#7ce4ff","router":true,"default-active":_vm.$route.path,"mode":"horizontal"}},[_c('el-menu-item',{attrs:{"index":"/"}},[_c('img',{staticStyle:{"height":"90%"},attrs:{"src":__webpack_require__("IN6/")}})]),_vm._v(" "),(_vm.$session.exists())?_c('div',[(_vm.$session.get('role') === 'admin')?_c('el-submenu',{attrs:{"align":"left","index":"/users","id":"user-menu"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-fa-users"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Users")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/users/list","id":"user-menu-list"}},[_c('i',{staticClass:"el-icon-fa-list-ul"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Tourinfo users list")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/users/create","id":"user-menu-create"}},[_c('i',{staticClass:"el-icon-fa-user-plus"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Create user")])])],2):_vm._e(),_vm._v(" "),_c('el-submenu',{attrs:{"align":"left","index":"/monuments"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-fa-globe"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Monuments")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/monuments/list"}},[_c('i',{staticClass:"el-icon-fa-list-ul"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Monuments list")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/monuments/create"}},[_c('i',{staticClass:"el-icon-fa-plus-circle"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Add monument")])])],2),_vm._v(" "),_c('el-submenu',{attrs:{"align":"left","index":"/walks"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-fa-compass"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Themed walks")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/walks/list"}},[_c('i',{staticClass:"el-icon-fa-list-ul"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Themed walks list")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/walks/create"}},[_c('i',{staticClass:"el-icon-fa-plus-circle"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Add new themed walk")])])],2),_vm._v(" "),_c('el-submenu',{attrs:{"align":"left","index":"/souvenirs"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-fa-gift"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Souvenirs")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/souvenirs/list"}},[_c('i',{staticClass:"el-icon-fa-list-ul"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Souvenirs list")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/souvenirs/create"}},[_c('i',{staticClass:"el-icon-fa-plus-circle"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Add new souvenir")])])],2),_vm._v(" "),_c('el-submenu',{attrs:{"align":"left","index":"/companies"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-fa-cutlery"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Partner companies")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/companies/list"}},[_c('i',{staticClass:"el-icon-fa-list-ul"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Partner companies list")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/companies/create"}},[_c('i',{staticClass:"el-icon-fa-plus-circle"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Add a new partner company")])])],2),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/about"}},[_c('i',{staticClass:"el-icon-info"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("About Us")])]),_vm._v(" "),_c('el-submenu',{staticClass:"menu-item-right",attrs:{"align":"left","index":"4","id":"logout-menu"}},[_c('template',{slot:"title"},[_c('img',{attrs:{"id":"navbar-profile-image","src":_vm.avatarUrl}}),_vm._v("\n        "+_vm._s(_vm.$session.get('username'))+"\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/profile"}},[_c('i',{staticClass:"el-icon-fa-pencil"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Edit profile")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/signout","id":"logout-menu-button"}},[_c('i',{staticClass:"el-icon-fa-sign-out"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Sign out")])])],2)],1):_c('div',[_c('el-menu-item',{attrs:{"id":"about-us","index":"/about"}},[_c('i',{staticClass:"el-icon-info"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("About Us")])]),_vm._v(" "),_c('el-menu-item',{staticClass:"menu-item-right",attrs:{"index":"/signin","id":"login-menu-button"}},[_c('i',{staticClass:"el-icon-fa-sign-in"}),_vm._v(" "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Sign in")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CASs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partner_Companies_List_View_vue__ = __webpack_require__("zCcU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7295c1ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partner_Companies_List_View_vue__ = __webpack_require__("32ry");
function injectStyle (ssrContext) {
  __webpack_require__("dfsQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partner_Companies_List_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7295c1ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partner_Companies_List_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CKBz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CVdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sign_In_vue__ = __webpack_require__("6TVv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3061618e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sign_In_vue__ = __webpack_require__("0IDu");
function injectStyle (ssrContext) {
  __webpack_require__("1yTl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sign_In_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3061618e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sign_In_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DUKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partner_Companies_Upload_Form_vue__ = __webpack_require__("OyQx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1880e873_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partner_Companies_Upload_Form_vue__ = __webpack_require__("JVNG");
function injectStyle (ssrContext) {
  __webpack_require__("HvN3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partner_Companies_Upload_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1880e873_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partner_Companies_Upload_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DZhf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dyd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Monument_List_vue__ = __webpack_require__("QdJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Reported_Comments_Newsfeed_vue__ = __webpack_require__("wGsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Comments_Newsfeed_vue__ = __webpack_require__("3kLC");
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'reported-comments-newsfeed': __WEBPACK_IMPORTED_MODULE_1__components_Reported_Comments_Newsfeed_vue__["a" /* default */],
    'monument-list': __WEBPACK_IMPORTED_MODULE_0__components_Monument_List_vue__["a" /* default */],
    'comments-newsfeed': __WEBPACK_IMPORTED_MODULE_2__components_Comments_Newsfeed_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "EonZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image_Uploader_vue__ = __webpack_require__("9fne");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'walk-upload-form',
  components: {
    'image-uploader': __WEBPACK_IMPORTED_MODULE_1__Image_Uploader_vue__["a" /* default */]
  },
  props: ['loaded-form'],
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$session.exists()) {
        next();
      } else {
        next('/signin');
      }
    });
  },
  data: function data() {
    var styleClass = this.loadedForm ? 'update-form' : 'form';
    var walkForm = this.loadedForm || {
      title: {
        hu: '',
        en: '',
        ro: ''
      },
      subtitle: {
        hu: '',
        en: '',
        ro: ''
      },
      description: {
        hu: '',
        en: '',
        ro: ''
      },
      images: []
    };
    walkForm.removedImages = [];
    walkForm.newImages = [];
    return {
      titlePlaceholder: {
        hu: this.$gettext('Title in Hungarian'),
        en: this.$gettext('Title in English'),
        ro: this.$gettext('Title in Romanian')
      },
      subtitlePlaceholder: {
        hu: this.$gettext('Subtitle in Hungarian'),
        en: this.$gettext('Subtitle in English'),
        ro: this.$gettext('Subtitle in Romanian')
      },
      descPlaceholder: {
        hu: this.$gettext('Description in Hungarian'),
        en: this.$gettext('Description in English'),
        ro: this.$gettext('Description in Romanian')
      },
      styleClass: styleClass,
      showName: false,
      showDesc: false,
      walkForm: walkForm,
      rules: {
        title: {
          type: 'object',
          required: true,
          fields: {
            hu: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add title') },
            en: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add title') },
            ro: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add title') }
          }
        },
        subtitle: {
          type: 'object',
          required: true,
          fields: {
            hu: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add subtitle') },
            en: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add subtitle') },
            ro: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add subtitle') }
          }
        },
        description: {
          type: 'object',
          required: true,
          fields: {
            hu: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            en: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            ro: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }]
          }
        },
        images: {
          type: 'array',
          required: true,
          message: this.$gettext('Please add images')
        }
      }
    };
  },

  methods: {
    substract: function substract(a, b) {
      return a.filter(function (element) {
        return b.indexOf(element) < 0;
      });
    },
    uploadForm: function uploadForm() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/walks',
        headers: { 'Content-Type': 'application/json' },
        data: this.walkForm,
        withCredentials: true
      }).then(function (response) {
        _this.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this.$router.push('/walks/list');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    updateForm: function updateForm() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/walks/' + this.walkForm.id,
        headers: { 'Content-Type': 'application/json' },
        data: this.walkForm,
        withCredentials: true
      }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this2.$emit('close-edit');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    cancel: function cancel() {
      var _this3 = this;

      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        _this3.$emit('close-edit');
      }).catch(function () {});
    },
    addImage: function addImage(imageFileName) {
      this.walkForm.newImages.push(imageFileName);
      this.walkForm.images.push(imageFileName);
    },
    removeImage: function removeImage(imageFileName) {
      this.walkForm.removedImages.push(imageFileName);
      this.walkForm.images.splice(this.walkForm.images.indexOf(imageFileName), 1);
      this.walkForm.newImages.splice(this.walkForm.newImages.indexOf(imageFileName), 1);
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;

      if (this.walkForm.images.length === 0) {
        this.walkForm.images = [].concat(this.walkForm.newImages);
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this4.loadedForm) {
            _this4.updateForm();
          } else {
            _this4.uploadForm();
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "Fyg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_User_Form_vue__ = __webpack_require__("7oaq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c77dab1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_User_Form_vue__ = __webpack_require__("0YIW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_User_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c77dab1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_User_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HvN3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IN6/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "IniZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-about-us"}},[_vm._v("Tourinfo Office")]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('p',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("\n      The TourInfo Office is in the center of Odorheiu Secuiesc, at Kossuth Lajos street 20 and it is maintained by the City Government.\n    ")]),_vm._v(" "),_c('p',[_c('translate',[_vm._v("The primary task of the TourInfo Office")]),_vm._v(":\n      "),_c('ul',[_c('li',[_c('translate',[_vm._v("inform tourists about accommodation and restaurants in the city and the surrounding area")])],1),_vm._v(" "),_c('li',[_c('translate',[_vm._v("prospectus about the sights of the city")])],1),_vm._v(" "),_c('li',[_c('translate',[_vm._v("promotion of timely events")])],1)])],1),_vm._v(" "),_c('p',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("\n      The office publishes the Tourism Catalog of Odorheiu Secuiesc and its surroundings every year from 2007. The brochure is published in 10,000 copies in four languages (Hungarian, Romanian, English, German). The catalog contains the brief story of the city, the sights, a city map, useful informations and informations about continuous programs and freetime activities.\n    ")]),_vm._v(" "),_c('h3',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Contacts")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Phone number")]),_vm._v(": +40-266-217427, +40-751-126278\n      ")]),_vm._v(" "),_c('li',[_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Email")]),_vm._v(": office@tourinfo.ro\n      ")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('h3',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Fellow workers")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n        Ilyés Emőke, "),_c('translate',[_vm._v("touristic professional performer")])],1),_vm._v(" "),_c('li',[_vm._v("\n        Péter Ildikó, "),_c('translate',[_vm._v("touristic referent")])],1),_vm._v(" "),_c('li',[_vm._v("\n        Orbán Melinda, "),_c('translate',[_vm._v("office manager")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('strong',[_vm._v("Facebook")]),_vm._v(": facebook.com/tourinfoiroda/\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JVNG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styleClass},[(!_vm.loadedForm)?_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-new-partner-company"}},[_vm._v("Add a new partner company")]):_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-edit-partner-company"}},[_vm._v("Edit partner company")]),_vm._v(" "),_c('el-form',{ref:"partnerCompanyForm",attrs:{"model":_vm.partnerCompanyForm,"rules":_vm.rules,"label-position":"left","label-width":"12em"}},[_c('el-form-item',{attrs:{"prop":"name"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Name")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","placeholder":_vm.namePlaceholder.hu},on:{"focus":function($event){_vm.showName=true}},model:{value:(_vm.partnerCompanyForm.name.hu),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm.name, "hu", $$v)},expression:"partnerCompanyForm.name.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showName),expression:"showName"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-en","placeholder":_vm.namePlaceholder.en},model:{value:(_vm.partnerCompanyForm.name.en),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm.name, "en", $$v)},expression:"partnerCompanyForm.name.en"}}),_c('br'),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-ro","placeholder":_vm.namePlaceholder.ro},model:{value:(_vm.partnerCompanyForm.name.ro),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm.name, "ro", $$v)},expression:"partnerCompanyForm.name.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"description"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","type":"textarea","placeholder":_vm.descriptionPlaceholder.hu},on:{"focus":function($event){_vm.showDescription=true}},model:{value:(_vm.partnerCompanyForm.description.hu),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm.description, "hu", $$v)},expression:"partnerCompanyForm.description.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDescription),expression:"showDescription"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-en","type":"textarea","placeholder":_vm.descriptionPlaceholder.en},model:{value:(_vm.partnerCompanyForm.description.en),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm.description, "en", $$v)},expression:"partnerCompanyForm.description.en"}}),_c('br'),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-ro","type":"textarea","placeholder":_vm.descriptionPlaceholder.ro},model:{value:(_vm.partnerCompanyForm.description.ro),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm.description, "ro", $$v)},expression:"partnerCompanyForm.description.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"category"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Category")]),_vm._v(" "),_c('el-select',{staticClass:"dropdown-style",attrs:{"placeholder":_vm.categoryPlaceholder},on:{"change":_vm.handleSelectionChange},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}},_vm._l((_vm.categories),function(value,key){return _c('el-option',{key:key,attrs:{"label":value,"value":key}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"address"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Address")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","placeholder":""},model:{value:(_vm.partnerCompanyForm.address),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm, "address", $$v)},expression:"partnerCompanyForm.address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"phone"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Phone number")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","placeholder":""},model:{value:(_vm.partnerCompanyForm.phone),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm, "phone", $$v)},expression:"partnerCompanyForm.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"website"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Website")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","placeholder":""},model:{value:(_vm.partnerCompanyForm.website),callback:function ($$v) {_vm.$set(_vm.partnerCompanyForm, "website", $$v)},expression:"partnerCompanyForm.website"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"position"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Coordinates")]),_vm._v(" "),_c('map-view',{attrs:{"id":"map-view","position":_vm.partnerCompanyForm.position,"is-editable":true},on:{"set-position":_vm.setPosition}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"images"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Images")]),_vm._v(" "),_c('image-uploader',{attrs:{"images":_vm.partnerCompanyForm.images},on:{"image-added":_vm.addImage,"image-removed":_vm.removeImage}})],1),_vm._v(" "),_c('el-form-item',[(_vm.loadedForm)?_c('el-button',{on:{"click":_vm.cancel}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Cancel")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"id":"button-upload","type":"primary"},on:{"click":function($event){return _vm.submitForm('partnerCompanyForm')}}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Update")]):_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Upload")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KHgw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KsP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list",attrs:{"id":"walk-list"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Themed walks")]),_vm._v(" "),_c('div',{staticClass:"create-button-container"},[(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-add-walk","type":"primary","icon":"el-icon-plus"},on:{"click":function($event){return _vm.$router.push('/walks/create')}}}):_vm._e()],1),_vm._v(" "),(_vm.walkList.length > 0)?_c('div',[(_vm.walkList)?_c('el-table',{attrs:{"id":"walk-table","data":_vm.walkListPage,"height":"100%"}},[_c('el-table-column',{staticClass:"walk-table-column",scopedSlots:_vm._u([{key:"default",fn:function(walk){return [_c('div',{staticClass:"walk-list-flex-container"},[_c('div',{staticClass:"walk-list-thumbnail"},[_c('img',{attrs:{"src":walk.row.thumbnailUrl}})]),_vm._v(" "),_c('div',{staticClass:"walk-list-content"},[_c('strong',[_c('translate',[_vm._v("Title")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(walk.row.title)),_c('br'),_vm._v(" "),_c('strong',[_c('translate',[_vm._v("Subtitle")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(walk.row.subtitle)+"\n            ")])])]}}],null,false,3868510774)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(walk){return [(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-edit","icon":"el-icon-edit"},on:{"click":function($event){return _vm.edit(walk.row.id)}}}):_vm._e(),_vm._v(" "),(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-delete","type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(walk.row.id)}}}):_vm._e()]}}],null,false,2640404580)})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.walkList.length,"current-page":_vm.currentPage,"page-size":_vm.pageSize},on:{"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event},"current-change":_vm.changePage}}),_vm._v(" "),(_vm.$session.exists() && _vm.isEditVisible)?_c('el-dialog',{attrs:{"before-close":_vm.handleClose,"visible":_vm.isEditVisible},on:{"update:visible":function($event){_vm.isEditVisible=$event}}},[_c('walk-upload-form',{attrs:{"loaded-form":_vm.walk,"preview":""},on:{"close-edit":_vm.closeEdit}})],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LBr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tourguide_Footer_vue__ = __webpack_require__("NVpR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf9e8d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tourguide_Footer_vue__ = __webpack_require__("YVor");
function injectStyle (ssrContext) {
  __webpack_require__("DZhf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tourguide_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf9e8d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tourguide_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LQwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_View_vue__ = __webpack_require__("ZpF2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d81a86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_View_vue__ = __webpack_require__("72Yd");
function injectStyle (ssrContext) {
  __webpack_require__("3Wu/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d81a86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5b9b72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("6GC9");
function injectStyle (ssrContext) {
  __webpack_require__("AseP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5b9b72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MNvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"reported-div"},[_c('h2',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"reported-title"},[_vm._v("Reported comments")]),_vm._v(" "),_c('hr',{staticClass:"delimiter"}),_vm._v(" "),_c('div',{staticClass:"reported-comment-list"},_vm._l((_vm.commentList),function(comment){return _c('el-card',{key:comment.id,staticClass:"comment",attrs:{"body-style":{ padding: '0px' }}},[_c('div',{staticClass:"comment-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"comments-user-icon",style:({background: _vm.getColor(comment.createdBy)})},[_vm._v("\n                  "+_vm._s(comment.createdBy[0].toUpperCase())+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"comment-title-and-content"},[_c('strong',{staticClass:"comment-title-content"},[_vm._v(_vm._s(comment.createdBy))]),_vm._v(" "),_c('div',{staticClass:"report-numbers"},[_c('i',{staticClass:"el-icon-warning red-icon"}),_vm._v(_vm._s(comment.reports)+" \n                  ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"comment-title-content"},[_vm._v(_vm._s(_vm.getDateTime(comment.date)))]),_vm._v(" "),_c('el-button',{staticClass:"delete-icon",attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(comment.id)}}})],1)]),_vm._v(" "),_c('p',{staticClass:"comment-content"},[_vm._v("\n                "+_vm._s(comment.comment)+"\n              ")])])}),1)])]),_vm._v(" "),_c('el-button',{attrs:{"id":"right-hide-button","size":"mini"},on:{"click":function($event){_vm.show=!_vm.show}}},[_c('div',{attrs:{"id":"vertical-right"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Reported comments")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mu8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_string_to_color__ = __webpack_require__("PVA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_string_to_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_string_to_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monument-list',
  data: function data() {
    return {
      commentList: [],
      show: true
    };
  },
  created: function created() {
    this.getReportedCommentList();
  },

  methods: {
    getColor: function getColor(string) {
      return '#' + __WEBPACK_IMPORTED_MODULE_1_string_to_color___default.a.generate(string);
    },
    getDateTime: function getDateTime(dateString) {
      var now = new Date();
      var date = new Date(dateString);
      if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
        return date.toTimeString().split(' ')[0];
      } else {
        return dateString.slice(0, 10).replace(/-/g, ' ');
      }
    },
    getReportedCommentList: function getReportedCommentList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/comments/reported',
        withCredentials: true
      }).then(function (response) {
        _this.commentList = response.data;
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    remove: function remove(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/comments/' + id,
        withCredentials: true
      }).then(function () {
        _this2.$message({
          type: 'success',
          message: _this2.$gettext('Comment deleted successfully!')
        });
        _this2.getReportedCommentList();
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__("6VMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gettext__ = __webpack_require__("Zoqe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gettext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_gettext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translations_json__ = __webpack_require__("6jlh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__translations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_session__ = __webpack_require__("18Sv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_session__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_gettext___default.a, {
  availableLanguages: {
    hu: 'Magyar',
    en: 'English',
    ro: 'Română'
  },
  defaultLanguage: 'hu',
  languageVmMixin: {
    computed: {
      currentKebabCase: function currentKebabCase() {
        return this.current.toLowerCase().replace('_', '-');
      }
    }
  },
  translations: __WEBPACK_IMPORTED_MODULE_6__translations_json___default.a,
  silent: true
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__, {
  load: {
    key: "AIzaSyDpTzHwm05En5pksFlgJ1vPKOhPrDy0AFU",
    libraries: 'places'
  }
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_session___default.a);

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */] }
});

/***/ }),

/***/ "NVpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tourguide-footer',
  data: function data() {
    return {
      lang: this.$localStorage.get('language')
    };
  },

  methods: {
    languageChanged: function languageChanged(lang) {
      this.$localStorage.set('language', lang);
      location.reload();
    }
  }
});

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OBxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Audio_Uploader_vue__ = __webpack_require__("e0WT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d7a5162_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audio_Uploader_vue__ = __webpack_require__("w3r4");
function injectStyle (ssrContext) {
  __webpack_require__("a5x8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Audio_Uploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d7a5162_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audio_Uploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OyQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Image_Uploader_vue__ = __webpack_require__("9fne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Map_View_vue__ = __webpack_require__("LQwd");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'partner-company-upload-form',
  components: {
    'image-uploader': __WEBPACK_IMPORTED_MODULE_4__Image_Uploader_vue__["a" /* default */],
    'map-view': __WEBPACK_IMPORTED_MODULE_5__Map_View_vue__["a" /* default */]
  },
  props: ['loaded-form'],
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$session.exists()) {
        next();
      } else {
        next('/signin');
      }
    });
  },
  data: function data() {
    var styleClass = this.loadedForm ? 'update-form' : 'form';
    var partnerCompanyForm = this.loadedForm || {
      name: {
        hu: null,
        en: null,
        ro: null
      },
      description: {
        hu: null,
        en: null,
        ro: null
      },
      category: null,
      address: null,
      phone: null,
      website: null,
      position: { lat: null, lng: null },
      images: []
    };
    partnerCompanyForm.removedImages = [];
    partnerCompanyForm.newImages = [];
    return {
      selectedValue: '',
      namePlaceholder: {
        hu: this.$gettext('Name in Hungarian'),
        en: this.$gettext('Name in English'),
        ro: this.$gettext('Name in Romanian')
      },
      descriptionPlaceholder: {
        hu: this.$gettext('Description in Hungarian'),
        en: this.$gettext('Description in English'),
        ro: this.$gettext('Description in Romanian')
      },
      categoryPlaceholder: this.$gettext('Select a category'),
      styleClass: styleClass,
      showName: false,
      showDescription: false,
      showCategory: false,
      partnerCompanyForm: partnerCompanyForm,
      categories: null,
      rules: {
        name: {
          type: 'object',
          required: true,
          fields: {
            hu: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') },
            en: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') },
            ro: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') }
          }
        },
        description: {
          type: 'object',
          required: false,
          fields: {
            hu: [{ type: 'string', required: false, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            en: [{ type: 'string', required: false, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            ro: [{ type: 'string', required: false, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }]
          }
        },
        category: {
          required: true,
          message: this.$gettext('Please choose a category')
        },
        images: {
          type: 'array',
          required: true,
          message: this.$gettext('Please add images')
        },
        address: {
          type: 'string',
          required: true,
          defaultField: { type: 'string', message: this.$gettext('Address is not valid') },
          message: this.$gettext('Please add address')
        },
        phone: {
          type: 'string',
          required: false,
          defaultField: { type: 'string', message: this.$gettext('Phone number is not valid') }
        },
        website: {
          type: 'url',
          required: false,
          defaultField: { type: 'url', message: this.$gettext('Url is not valid') },
          message: this.$gettext('Invalid website URL')
        },
        position: {
          type: 'object',
          required: true,
          message: this.$gettext('Please set the coordinates'),
          trigger: 'change',
          fields: {
            lat: { type: 'float', required: true, message: this.$gettext('Please set the coordinates') },
            lng: { type: 'float', required: true, message: this.$gettext('Please set the coordinates') }
          }
        }
      }
    };
  },
  created: function created() {
    this.getCategories();
    if (this.loadedForm) {
      this.selectedValue = this.partnerCompanyForm.category[this.$language.current];
    }
  },

  methods: {
    substract: function substract(a, b) {
      return a.filter(function (element) {
        return b.indexOf(element) < 0;
      });
    },
    handleSelectionChange: function handleSelectionChange(key) {
      this.partnerCompanyForm.category = key;
    },
    handleSelectionClick: function handleSelectionClick() {},
    setPosition: function setPosition(position) {
      this.partnerCompanyForm.position = position;
    },
    getCategories: function getCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/companies/categories?lang=' + this.$language.current
      }).then(function (response) {
        _this.categories = response.data;
      });
    },
    uploadForm: function uploadForm() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/companies',
        headers: { 'Content-Type': 'application/json' },
        data: this.partnerCompanyForm,
        withCredentials: true
      }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this2.$router.push('/companies/list');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    updateForm: function updateForm() {
      var _this3 = this;

      var categoryKey = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.categories)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value === this.selectedValue) {
            categoryKey = key;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (categoryKey === '') {
        categoryKey = this.selectedValue;
      }
      this.partnerCompanyForm.category = categoryKey;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'put',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/companies/' + this.partnerCompanyForm.id,
        headers: { 'Content-Type': 'application/json' },
        data: this.partnerCompanyForm,
        withCredentials: true
      }).then(function (response) {
        _this3.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this3.$emit('close-edit');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this3.$message({
          type: 'error',
          message: msg
        });
      });
    },
    cancel: function cancel() {
      var _this4 = this;

      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        _this4.$emit('close-edit');
      }).catch(function () {});
    },
    addRow: function addRow() {
      this.partnerCompanyForm.urls.push('');
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    saveRow: function saveRow(index, rows, row) {
      rows.splice(index, 1, row);
    },
    addImage: function addImage(imageFileName) {
      this.partnerCompanyForm.newImages.push(imageFileName);
    },
    removeImage: function removeImage(imageFileName) {
      this.partnerCompanyForm.removedImages.push(imageFileName);
      this.partnerCompanyForm.images.splice(this.partnerCompanyForm.images.indexOf(imageFileName), 1);
      this.partnerCompanyForm.newImages.splice(this.partnerCompanyForm.newImages.indexOf(imageFileName), 1);
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;

      if (this.partnerCompanyForm.images.length === 0) {
        this.partnerCompanyForm.images = [].concat(this.partnerCompanyForm.newImages);
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this5.loadedForm) {
            _this5.updateForm();
          } else {
            _this5.uploadForm();
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "PJGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$session.exists() && _vm.$route.path !=='/')?_c('div',[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"comment-div"},[_c('h2',{staticClass:"comment-maintitle"},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Comments")]),_vm._v(" ")]),_vm._v(" "),_c('hr',{staticClass:"delimiter"}),_vm._v(" "),_c('div',{staticClass:"comment-list"},_vm._l((_vm.commentList),function(comment){return _c('el-card',{key:comment.id,attrs:{"body-style":{ padding: '0px' }}},[_c('div',{staticClass:"comment-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"comments-user-icon",style:({background: _vm.getColor(comment.createdBy)})},[_vm._v("\n              "+_vm._s(comment.createdBy[0].toUpperCase())+"\n            ")]),_vm._v(" "),_c('div',[_c('strong',{staticClass:"comment-title-content"},[_vm._v(_vm._s(comment.createdBy))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"comment-title-content"},[_vm._v(_vm._s(_vm.getDateTime(comment.date)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"comment-title-content",attrs:{"href":_vm.getMonumentUrl(comment.monumentId),"target":"_blank"}},[_vm._v(_vm._s(comment.monumentName[_vm.$language.current]))])])]),_vm._v(" "),_c('p',{staticClass:"comment-content"},[_vm._v("\n            "+_vm._s(comment.comment)+"\n          ")])])}),1)])]),_vm._v(" "),_c('el-button',{attrs:{"id":"left-hide-button","size":"mini"},on:{"click":function($event){_vm.show=!_vm.show}}},[_c('div',{attrs:{"id":"vertical-left"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Comments")])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PVab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sign-out',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$session.exists()) {
        next();
      } else {
        next('/signin');
      }
    });
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      method: 'post',
      url: "https://tourinfo.pedu.codespring.ro:443/api" + '/auth/logout',
      withCredentials: true
    }).then(function () {
      _this.$session.destroy();
      window.location = '/';
      _this.$message({
        type: 'success',
        message: _this.$gettext('Signed out')
      });
    }).catch(function (error) {
      var msg;
      if (error.response) {
        msg = error.response.data || error.response.statusText;
      } else {
        msg = error.message;
      }
      _this.$message({
        type: 'error',
        message: msg
      });
    });
  }
});

/***/ }),

/***/ "QOuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QdJ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monument_List_vue__ = __webpack_require__("15zi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1687d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monument_List_vue__ = __webpack_require__("YyqF");
function injectStyle (ssrContext) {
  __webpack_require__("uTy2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monument_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1687d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monument_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Spo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Souvenir_Create_Update_Form_vue__ = __webpack_require__("/VFR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'souvenir-list',
  data: function data() {
    var menuItems = {
      images: 'images'
    };
    return {
      menuItems: menuItems,
      activeMenuImagesOrMap: menuItems.images,
      isEditVisible: false,
      monumentId: null,
      monument: null,
      souvenirList: [],
      currentPage: 1,
      pageSize: 10,
      souvenirListPage: []
    };
  },
  created: function created() {
    this.getSouvenirList();
  },

  components: {
    'souvenir-upload-form': __WEBPACK_IMPORTED_MODULE_1__Souvenir_Create_Update_Form_vue__["a" /* default */]
  },
  methods: {
    changePage: function changePage() {
      this.souvenirListPage = this.souvenirList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    getSouvenirList: function getSouvenirList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/souvenirs?lang=' + this.$language.current,
        withCredentials: true
      }).then(function (response) {
        _this.souvenirList = response.data;
        _this.souvenirListPage = _this.souvenirList.slice((_this.currentPage - 1) * _this.pageSize, _this.currentPage * _this.pageSize);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    getSouvenir: function getSouvenir(id, callback) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/souvenirs/' + id,
        withCredentials: true
      }).then(function (response) {
        _this2.souvenir = response.data;
        callback(null);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
        callback(error);
      });
    },
    handleClose: function handleClose(done) {
      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        done();
      }).catch(function () {});
    },
    edit: function edit(id) {
      var _this3 = this;

      this.getSouvenir(id, function (error) {
        if (!error) {
          _this3.isEditVisible = true;
        }
      });
    },
    closeEdit: function closeEdit() {
      this.isEditVisible = false;
      this.getSouvenirList();
    },
    remove: function remove(id) {
      var _this4 = this;

      this.$confirm(this.$gettext('Are you sure to delete the souvenir?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'delete',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/souvenirs/' + id,
          withCredentials: true
        }).then(function () {
          _this4.$message({
            type: 'success',
            message: _this4.$gettext('Delete has completed')
          });
          _this4.getSouvenirList();
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this4.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: _this4.$gettext('Delete has canceled')
        });
      });
    }
  }
});

/***/ }),

/***/ "TmfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sign_Out_vue__ = __webpack_require__("PVab");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484e20fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sign_Out_vue__ = __webpack_require__("2jB+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sign_Out_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484e20fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sign_Out_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U/II":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vdxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Souvenir_List_View_vue__ = __webpack_require__("Spo2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5afbde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Souvenir_List_View_vue__ = __webpack_require__("iC1K");
function injectStyle (ssrContext) {
  __webpack_require__("W0Xb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Souvenir_List_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5afbde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Souvenir_List_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VyxN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cs-logo.6afa208.png";

/***/ }),

/***/ "W0Xb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wij+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TI_User_List_vue__ = __webpack_require__("bJal");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d8fdaa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TI_User_List_vue__ = __webpack_require__("6FI2");
function injectStyle (ssrContext) {
  __webpack_require__("U/II")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TI_User_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d8fdaa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TI_User_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YVor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('el-menu',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-flex-container"},[_c('div',{staticClass:"footer-flex-container"},[_c('translate',[_vm._v("Powered by")]),_vm._v(": \n        "),_c('a',{attrs:{"href":"http://www.codespring.ro/","target":"_blank"}},[_c('img',{attrs:{"id":"footer-image","src":__webpack_require__("VyxN")}})]),_vm._v(" &\n        "),_c('a',{attrs:{"href":"https://u-hub.ro/","target":"_blank"}},[_c('img',{attrs:{"id":"footer-image","src":__webpack_require__("lxRE")}})])],1),_vm._v(" "),_c('div',{staticClass:"footer-flex-container"},[_c('translate',[_vm._v("Language")]),_vm._v(": \n        "),_c('el-select',{attrs:{"id":"language-selector","name":"language"},on:{"change":_vm.languageChanged},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}},_vm._l((_vm.$language.available),function(language,key){return _c('el-option',{key:key,attrs:{"label":_vm.$gettext(language),"value":key}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"footer-flex-container"},[_vm._v("\n        Copyright © 2017-2024. "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("All rights reserved.")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About_Us_vue__ = __webpack_require__("7Riu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Create_User_Form_vue__ = __webpack_require__("Fyg4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Monument_Detailed_View__ = __webpack_require__("9Yw5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Monument_Upload_Form_vue__ = __webpack_require__("gA6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Sign_In_vue__ = __webpack_require__("CVdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Sign_Out_vue__ = __webpack_require__("TmfO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Update_Profile_Form_vue__ = __webpack_require__("cfPm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TI_User_List_vue__ = __webpack_require__("Wij+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Home_Page_vue__ = __webpack_require__("2nxs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Souvenir_List_View_vue__ = __webpack_require__("Vdxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Souvenir_Create_Update_Form_vue__ = __webpack_require__("/VFR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Partner_Companies_List_View_vue__ = __webpack_require__("CASs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Partner_Companies_Upload_Form_vue__ = __webpack_require__("DUKa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Walk_Upload_Form_vue__ = __webpack_require__("AAmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Walk_List_View_vue__ = __webpack_require__("/d0K");


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_10__components_Home_Page_vue__["a" /* default */] }, { path: '/users/list', component: __WEBPACK_IMPORTED_MODULE_9__components_TI_User_List_vue__["a" /* default */] }, { path: '/users/create', component: __WEBPACK_IMPORTED_MODULE_3__components_Create_User_Form_vue__["a" /* default */] }, { path: '/monuments/list', component: __WEBPACK_IMPORTED_MODULE_10__components_Home_Page_vue__["a" /* default */] }, { path: '/monuments/create', component: __WEBPACK_IMPORTED_MODULE_5__components_Monument_Upload_Form_vue__["a" /* default */] }, { path: '/monuments/:id', component: __WEBPACK_IMPORTED_MODULE_4__components_Monument_Detailed_View__["a" /* default */], props: true }, { path: '/profile', component: __WEBPACK_IMPORTED_MODULE_8__components_Update_Profile_Form_vue__["a" /* default */] }, { path: '/signin', component: __WEBPACK_IMPORTED_MODULE_6__components_Sign_In_vue__["a" /* default */] }, { path: '/signout', component: __WEBPACK_IMPORTED_MODULE_7__components_Sign_Out_vue__["a" /* default */] }, { path: '/about', component: __WEBPACK_IMPORTED_MODULE_2__components_About_Us_vue__["a" /* default */] }, { path: '/souvenirs/list', component: __WEBPACK_IMPORTED_MODULE_11__components_Souvenir_List_View_vue__["a" /* default */] }, { path: '/souvenirs/create', component: __WEBPACK_IMPORTED_MODULE_12__components_Souvenir_Create_Update_Form_vue__["a" /* default */] }, { path: '/companies/list', component: __WEBPACK_IMPORTED_MODULE_13__components_Partner_Companies_List_View_vue__["a" /* default */] }, { path: '/companies/create', component: __WEBPACK_IMPORTED_MODULE_14__components_Partner_Companies_Upload_Form_vue__["a" /* default */] }, { path: '/souvenirs/create', component: __WEBPACK_IMPORTED_MODULE_12__components_Souvenir_Create_Update_Form_vue__["a" /* default */] }, { path: '/walks/create', component: __WEBPACK_IMPORTED_MODULE_15__components_Walk_Upload_Form_vue__["a" /* default */] }, { path: '/walks/list', component: __WEBPACK_IMPORTED_MODULE_16__components_Walk_List_View_vue__["a" /* default */] }]
});

router.beforeEach(function (to, from, next) {
  if (router.match(to).matched.length === 0) {
    next('/');
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YyqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$session.exists() && _vm.$route.path !=='/')?_c('div',{staticClass:"list",attrs:{"id":"monument-list"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Monuments")]),_vm._v(" "),_c('div',{staticClass:"create-button-container"},[(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-add-monument","type":"primary","icon":"el-icon-plus"},on:{"click":function($event){return _vm.$router.push('/monuments/create')}}}):_vm._e()],1),_vm._v(" "),(_vm.monumentList.length > 0)?_c('div',[(_vm.monumentList)?_c('el-table',{attrs:{"id":"monument-table","data":_vm.monumentListPage,"height":"100%"}},[_c('el-table-column',{staticClass:"monument-table-column",scopedSlots:_vm._u([{key:"default",fn:function(monument){return [_c('div',{staticClass:"monument-list-flex-container"},[_c('div',{staticClass:"monument-list-thumbnail"},[_c('img',{attrs:{"src":monument.row.thumbnailUrl}})]),_vm._v(" "),_c('div',{staticClass:"monument-list-content"},[_c('span',{staticClass:"clickable-text",on:{"click":function($event){return _vm.preview(monument.row.id)}}},[_c('strong',[_vm._v("\n                  "+_vm._s(monument.row.name)+"\n                ")])]),_vm._v(" "),_c('el-rate',{attrs:{"disabled":"","show-score":"","text-color":"#ff9900","score-template":_vm.points},model:{value:(monument.row.rating),callback:function ($$v) {_vm.$set(monument.row, "rating", $$v)},expression:"monument.row.rating"}})],1)])]}}],null,false,1676020399)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(monument){return [(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-edit","icon":"el-icon-edit"},on:{"click":function($event){return _vm.edit(monument.row.id)}}}):_vm._e(),_vm._v(" "),(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-delete","type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(monument.row.id)}}}):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"info","id":"button-preview","icon":"el-icon-arrow-right"},on:{"click":function($event){return _vm.preview(monument.row.id)}}}),_vm._v(" "),(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-download-qr","icon":"el-icon-fa-qrcode"},on:{"click":function($event){return _vm.downloadQr(monument.row.id, monument.row.name)}}}):_vm._e()]}}],null,false,3165735891)})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.monumentList.length,"current-page":_vm.currentPage,"page-size":_vm.pageSize},on:{"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event},"current-change":_vm.changePage}}),_vm._v(" "),(_vm.$session.exists() && _vm.isEditVisible)?_c('el-dialog',{attrs:{"before-close":_vm.handleClose,"visible":_vm.isEditVisible},on:{"update:visible":function($event){_vm.isEditVisible=$event}}},[_c('monument-upload-form',{attrs:{"loaded-form":_vm.monument,"preview":""},on:{"close-edit":_vm.closeEdit}})],1):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isPreviewVisible,"before-close":_vm.closePreview},on:{"update:visible":function($event){_vm.isPreviewVisible=$event}}},[(_vm.isPreviewVisible)?_c('div',{staticClass:"preview"},[_c('monument-detailed-view',{attrs:{"id":_vm.monumentId,"preview":true}})],1):_vm._e()])],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z+cW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-uploader',
  props: ['images'],
  data: function data() {
    var uploadedImages = [];
    if (this.images && this.images.length > 0) {
      this.images.map(function (tmpImage, index, arr) {
        uploadedImages.push({
          response: tmpImage.split('/').pop(),
          url: tmpImage
        });
        arr.splice(index, 1, tmpImage.split('/').pop());
      });
    }
    return {
      uploadUrl: "https://tourinfo.pedu.codespring.ro:443/api" + '/images',
      dialogImageUrl: '',
      isDialogVisible: false,
      uploadedImages: uploadedImages
    };
  },

  methods: {
    remove: function remove(file) {
      this.$emit('image-removed', file.response);
    },
    preview: function preview(file) {
      this.dialogImageUrl = file.url;
      this.isDialogVisible = true;
    },
    add: function add(response) {
      this.$emit('image-added', response);
    }
  }
});

/***/ }),

/***/ "ZpF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map-view',
  props: ['position', 'is-editable'],
  data: function data() {
    var center = {lat: 46.3064986, lng: 25.2965902};
    if (this.position.lat !== null && this.position.lng !== null) {
      center = this.position;
    }
    return {
      center: center,
      pos: this.position
    };
  },

  computed: {
    posText: function posText() {
      return this.pos.lat + ', ' + this.pos.lng;
    }
  },
  methods: {
    usePlace: function usePlace(place) {
      if (this.isEditable && place) {
        this.pos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
        this.$emit('set-position', this.pos);
      }
    },
    setPosition: function setPosition(position) {
      if (this.isEditable) {
        this.pos = {
          lat: position.latLng.lat(),
          lng: position.latLng.lng()
        };
        this.$emit('set-position', this.pos);
      }
    }
  }
});

/***/ }),

/***/ "a5x8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bJal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_md5__ = __webpack_require__("L6bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ti-user-list',
  data: function data() {
    return {
      username: this.$gettext('Username'),
      fullName: this.$gettext('Full name'),
      role: this.$gettext('Role'),
      userList: []
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.$session.exists()) {
        if (vm.$session.get('role') === 'admin') {
          next();
        } else {
          _this.$message({
            type: 'warning',
            message: _this.$gettext('Please sign out and sign in as an admin user!')
          });
          next('/');
        }
      } else {
        next('/signin');
      }
    });
  },
  created: function created() {
    this.getUserList();
  },

  methods: {
    avatarUrl: function avatarUrl(email) {
      return 'https://www.gravatar.com/avatar/' + __WEBPACK_IMPORTED_MODULE_1_md5___default()(email.trim().toLowerCase());
    },
    activeFontColor: function activeFontColor(status) {
      if (status === 'active') {
        return {
          color: 'green'
        };
      } else {
        return {
          color: 'red'
        };
      }
    },
    getUserList: function getUserList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users',
        withCredentials: true
      }).then(function (response) {
        var tiUsers = [];
        response.data.map(function (user) {
          if (user.role === 'TI User') {
            tiUsers.push(user);
          }
        });
        _this2.userList = tiUsers;
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    deactivate: function deactivate(id) {
      var _this3 = this;

      this.$confirm(this.$gettext('Are you sure to deactivate the user?'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'post',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/' + id + '/deactivate',
          withCredentials: true
        }).then(function () {
          _this3.$message({
            type: 'success',
            message: _this3.$gettext('User has deactivated')
          });
          _this3.getUserList();
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this3.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: _this3.$gettext('Deactivate has canceled')
        });
      });
    },
    activate: function activate(id) {
      var _this4 = this;

      this.$confirm(this.$gettext('Are you sure to activate the user?'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'post',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/' + id + '/activate',
          withCredentials: true
        }).then(function () {
          _this4.$message({
            type: 'success',
            message: _this4.$gettext('User has been activated')
          });
          _this4.getUserList();
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this4.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: _this4.$gettext('Activation was canceled')
        });
      });
    },
    resetPassword: function resetPassword(id) {
      var _this5 = this;

      this.$confirm(this.$gettext('Are you sure to reset the user\'s password?'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'post',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/' + id + '/reset',
          withCredentials: true
        }).then(function () {
          _this5.$message({
            type: 'success',
            message: _this5.$gettext('Password has reseted')
          });
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this5.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: _this5.$gettext('Password reset has canceled')
        });
      });
    }
  }
});

/***/ }),

/***/ "bh3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Update_Profile_Form_vue__ = __webpack_require__("qPsv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1482c363_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Update_Profile_Form_vue__ = __webpack_require__("dsU4");
function injectStyle (ssrContext) {
  __webpack_require__("r3e2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Update_Profile_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1482c363_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Update_Profile_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ckXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('monument-list'),_vm._v(" "),_c('div',{attrs:{"id":"comments"}},[_c('comments-newsfeed'),_vm._v(" "),(_vm.$session.exists()  && _vm.$route.path !=='/')?_c('reported-comments-newsfeed'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dfsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dsU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Edit profile")]),_vm._v(" "),_c('div',{staticClass:"profile"},[_c('img',{staticClass:"profile-image",attrs:{"src":_vm.avatarUrl()}}),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(this.$session.get('username')))])]),_vm._v(" "),_c('el-form',{ref:"userForm",attrs:{"model":_vm.userForm,"rules":_vm.rules,"label-position":"left","label-width":"12em"}},[_c('el-form-item',[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Email")]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true,"type":"email"},model:{value:(_vm.userForm.email),callback:function ($$v) {_vm.$set(_vm.userForm, "email", $$v)},expression:"userForm.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"firstName"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("First name")]),_vm._v(" "),_c('el-input',{attrs:{"prop":"firstName"},model:{value:(_vm.userForm.firstName),callback:function ($$v) {_vm.$set(_vm.userForm, "firstName", $$v)},expression:"userForm.firstName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"lastName"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Last name")]),_vm._v(" "),_c('el-input',{attrs:{"prop":"lastName"},model:{value:(_vm.userForm.lastName),callback:function ($$v) {_vm.$set(_vm.userForm, "lastName", $$v)},expression:"userForm.lastName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"phoneNumber"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Phone number")]),_vm._v(" "),_c('el-input',{attrs:{"prop":"phoneNumber"},model:{value:(_vm.userForm.phoneNumber),callback:function ($$v) {_vm.$set(_vm.userForm, "phoneNumber", $$v)},expression:"userForm.phoneNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Change password")]),_vm._v(" "),_c('el-input',{attrs:{"type":_vm.password.type},model:{value:(_vm.password.value),callback:function ($$v) {_vm.$set(_vm.password, "value", $$v)},expression:"password.value"}},[_c('el-button',{attrs:{"slot":"append","icon":_vm.password.icon},on:{"click":_vm.showPassword},slot:"append"})],1)],1),_vm._v(" "),_c('el-form-item',[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Role")]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.userForm.role),callback:function ($$v) {_vm.$set(_vm.userForm, "role", $$v)},expression:"userForm.role"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submitForm}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Update")])]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.resetForm}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Reset")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e0WT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'audio-uploader',
  props: ['loaded-audio', 'lang'],
  data: function data() {
    var uploadedAudio = [];
    if (this.loadedAudio) {
      uploadedAudio.push({
        name: this.loadedAudio.split('/').pop(),
        url: this.loadedAudio
      });
    }
    var uploadTooltip = '';
    switch (this.lang) {
      case 'hu':
        uploadTooltip = this.$gettext('Upload hungarian audio');
        break;
      case 'en':
        uploadTooltip = this.$gettext('Upload english audio');
        break;
      case 'ro':
        uploadTooltip = this.$gettext('Upload romanian audio');
        break;
    }
    return {
      uploadTooltip: uploadTooltip,
      uploadUrl: "https://tourinfo.pedu.codespring.ro:443/api" + '/audios',
      dialogAudioUrl: '',
      isDialogVisible: false,
      uploadedAudio: uploadedAudio
    };
  },

  methods: {
    handleSuccess: function handleSuccess(response) {
      this.$emit('audio-file-changed', response.split('/').pop());
    },
    handleRemove: function handleRemove(file) {
      this.$emit('audio-file-removed', file.response);
    },
    handlePreview: function handlePreview(file) {
      this.dialogAudioUrl = file.url;
      this.isDialogVisible = true;
    },
    handleExceed: function handleExceed() {
      this.$message({
        type: 'warning',
        message: this.$gettext('Only one file can be uploaded!')
      });
    }
  }
});

/***/ }),

/***/ "eHOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image_Uploader_vue__ = __webpack_require__("9fne");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'souvenir-upload-form',
  components: {
    'image-uploader': __WEBPACK_IMPORTED_MODULE_1__Image_Uploader_vue__["a" /* default */]
  },
  props: ['loaded-form'],
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$session.exists()) {
        next();
      } else {
        next('/signin');
      }
    });
  },
  data: function data() {
    var styleClass = this.loadedForm ? 'update-form' : 'form';
    var souvenirForm = this.loadedForm || {
      name: {
        hu: '',
        en: '',
        ro: ''
      },
      description: {
        hu: '',
        en: '',
        ro: ''
      },
      images: []
    };
    souvenirForm.removedImages = [];
    souvenirForm.newImages = [];
    return {
      namePlaceholder: {
        hu: this.$gettext('Name in Hungarian'),
        en: this.$gettext('Name in English'),
        ro: this.$gettext('Name in Romanian')
      },
      descPlaceholder: {
        hu: this.$gettext('Description in Hungarian'),
        en: this.$gettext('Description in English'),
        ro: this.$gettext('Description in Romanian')
      },
      styleClass: styleClass,
      showName: false,
      showDesc: false,
      souvenirForm: souvenirForm,
      rules: {
        name: {
          type: 'object',
          required: true,
          fields: {
            hu: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') },
            en: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') },
            ro: { type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name') }
          }
        },
        description: {
          type: 'object',
          required: true,
          fields: {
            hu: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            en: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }],
            ro: [{ type: 'string', required: true, message: this.$gettext('Please add description') }, { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }]
          }
        },
        images: {
          type: 'array',
          required: true,
          message: this.$gettext('Please add images')
        },
        price: {
          required: true,
          message: this.$gettext('Please enter the price of the item or validate the number')
        }
      }
    };
  },

  methods: {
    substract: function substract(a, b) {
      return a.filter(function (element) {
        return b.indexOf(element) < 0;
      });
    },
    uploadForm: function uploadForm() {
      var _this = this;

      var tempPrice = this.souvenirForm.price;
      if (tempPrice != null && !tempPrice || tempPrice < 0 || tempPrice > 10000000) {
        return null;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/souvenirs',
        headers: { 'Content-Type': 'application/json' },
        data: this.souvenirForm,
        withCredentials: true
      }).then(function (response) {
        _this.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this.$router.push('/souvenirs/list');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    updateForm: function updateForm() {
      var _this2 = this;

      var tempPrice = this.souvenirForm.price;
      if (tempPrice != null && !tempPrice || tempPrice < 0 || tempPrice > 10000000) {
        return null;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/souvenirs/' + this.souvenirForm.id,
        headers: { 'Content-Type': 'application/json' },
        data: this.souvenirForm,
        withCredentials: true
      }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: response.data || response.statusText
        });
        _this2.$emit('close-edit');
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    cancel: function cancel() {
      var _this3 = this;

      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        _this3.$emit('close-edit');
      }).catch(function () {});
    },
    addImage: function addImage(imageFileName) {
      this.souvenirForm.newImages.push(imageFileName);
      this.souvenirForm.images.push(imageFileName);
    },
    removeImage: function removeImage(imageFileName) {
      this.souvenirForm.removedImages.push(imageFileName);
      this.souvenirForm.images.splice(this.souvenirForm.images.indexOf(imageFileName), 1);
      this.souvenirForm.newImages.splice(this.souvenirForm.newImages.indexOf(imageFileName), 1);
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;

      if (this.souvenirForm.images.length === 0) {
        this.souvenirForm.images = [].concat(this.souvenirForm.newImages);
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this4.loadedForm) {
            _this4.updateForm();
          } else {
            _this4.uploadForm();
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "gA6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monument_Upload_Form_vue__ = __webpack_require__("7l1b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355bd1e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monument_Upload_Form_vue__ = __webpack_require__("5AJL");
function injectStyle (ssrContext) {
  __webpack_require__("/cg2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monument_Upload_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_355bd1e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monument_Upload_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iC1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list",attrs:{"id":"souvenir-list"}},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Souvenirs")]),_vm._v(" "),_c('div',{staticClass:"create-button-container"},[(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-add-souvenir","type":"primary","icon":"el-icon-plus"},on:{"click":function($event){return _vm.$router.push('/souvenirs/create')}}}):_vm._e()],1),_vm._v(" "),(_vm.souvenirList.length > 0)?_c('div',[(_vm.souvenirList)?_c('el-table',{attrs:{"id":"souvenir-table","data":_vm.souvenirListPage,"height":"100%"}},[_c('el-table-column',{staticClass:"souvenir-table-column",scopedSlots:_vm._u([{key:"default",fn:function(souvenir){return [_c('div',{staticClass:"souvenir-list-flex-container"},[_c('div',{staticClass:"souvenir-list-thumbnail"},[_c('img',{attrs:{"src":souvenir.row.thumbnailUrl}})]),_vm._v(" "),_c('div',{staticClass:"souvenir-list-content"},[_c('strong',[_c('translate',[_vm._v("Name")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(souvenir.row.name)),_c('br'),_vm._v(" "),_c('strong',[_c('translate',[_vm._v("Description")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(souvenir.row.description)),_c('br'),_vm._v(" "),_c('strong',[_c('translate',[_vm._v("Price")]),_vm._v(":")],1),_vm._v(" \n                "+_vm._s(souvenir.row.price)+" RON\n            ")])])]}}],null,false,3394561945)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(souvenir){return [(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-edit","icon":"el-icon-edit"},on:{"click":function($event){return _vm.edit(souvenir.row.id)}}}):_vm._e(),_vm._v(" "),(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"id":"button-delete","type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(souvenir.row.id)}}}):_vm._e()]}}],null,false,1187015514)})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.souvenirList.length,"current-page":_vm.currentPage,"page-size":_vm.pageSize},on:{"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event},"current-change":_vm.changePage}}),_vm._v(" "),(_vm.$session.exists() && _vm.isEditVisible)?_c('el-dialog',{attrs:{"before-close":_vm.handleClose,"visible":_vm.isEditVisible},on:{"update:visible":function($event){_vm.isEditVisible=$event}}},[_c('souvenir-upload-form',{attrs:{"loaded-form":_vm.souvenir,"preview":""},on:{"close-edit":_vm.closeEdit}})],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jb7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tourguide_Navbar_vue__ = __webpack_require__("pTSc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb3c93e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tourguide_Navbar_vue__ = __webpack_require__("BsbS");
function injectStyle (ssrContext) {
  __webpack_require__("1FSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tourguide_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb3c93e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tourguide_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kOa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{attrs:{"name":"image","with-credentials":true,"file-list":_vm.uploadedImages,"action":_vm.uploadUrl,"multiple":"","list-type":"picture-card","on-preview":_vm.preview,"on-remove":_vm.remove,"on-success":_vm.add,"accept":"image/*"}},[_c('i',{staticClass:"el-icon-plus"})]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isDialogVisible,"append-to-body":true},on:{"update:visible":function($event){_vm.isDialogVisible=$event}}},[_c('img',{attrs:{"width":"100%","src":_vm.dialogImageUrl,"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lJHS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lxRE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u-hub-logo.97a5274.png";

/***/ }),

/***/ "mACx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styleClass},[(!_vm.loadedForm)?_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-new-souvenir"}},[_vm._v("Add new souvenir")]):_c('h1',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"id":"title-edit-souvenir"}},[_vm._v("Edit souvenir")]),_vm._v(" "),_c('el-form',{ref:"souvenirForm",attrs:{"model":_vm.souvenirForm,"rules":_vm.rules,"label-position":"left","label-width":"12em"}},[_c('el-form-item',{attrs:{"prop":"name"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Name")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-name","placeholder":_vm.namePlaceholder.hu},on:{"focus":function($event){_vm.showName=true}},model:{value:(_vm.souvenirForm.name.hu),callback:function ($$v) {_vm.$set(_vm.souvenirForm.name, "hu", $$v)},expression:"souvenirForm.name.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showName),expression:"showName"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-en","placeholder":_vm.namePlaceholder.en},model:{value:(_vm.souvenirForm.name.en),callback:function ($$v) {_vm.$set(_vm.souvenirForm.name, "en", $$v)},expression:"souvenirForm.name.en"}}),_c('br'),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-name-ro","placeholder":_vm.namePlaceholder.ro},model:{value:(_vm.souvenirForm.name.ro),callback:function ($$v) {_vm.$set(_vm.souvenirForm.name, "ro", $$v)},expression:"souvenirForm.name.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"description"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-desciption","type":"textarea","placeholder":_vm.descPlaceholder.hu},on:{"focus":function($event){_vm.showDesc=true}},model:{value:(_vm.souvenirForm.description.hu),callback:function ($$v) {_vm.$set(_vm.souvenirForm.description, "hu", $$v)},expression:"souvenirForm.description.hu"}}),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDesc),expression:"showDesc"}]},[_c('el-input',{staticClass:"input-style",attrs:{"id":"input-desciption-en","type":"textarea","placeholder":_vm.descPlaceholder.en},model:{value:(_vm.souvenirForm.description.en),callback:function ($$v) {_vm.$set(_vm.souvenirForm.description, "en", $$v)},expression:"souvenirForm.description.en"}}),_vm._v(" "),_c('el-input',{staticClass:"input-style",attrs:{"id":"input-desciption-ro","type":"textarea","placeholder":_vm.descPlaceholder.ro},model:{value:(_vm.souvenirForm.description.ro),callback:function ($$v) {_vm.$set(_vm.souvenirForm.description, "ro", $$v)},expression:"souvenirForm.description.ro"}})],1)])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"price"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Price")]),_vm._v(" "),_c('el-input',{attrs:{"id":"input-price","type":"number","min":"0","placeholder":this.$gettext('Please enter the price of the item')},model:{value:(_vm.souvenirForm.price),callback:function ($$v) {_vm.$set(_vm.souvenirForm, "price", $$v)},expression:"souvenirForm.price"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"images"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"slot":"label"},slot:"label"},[_vm._v("Images")]),_vm._v(" "),_c('image-uploader',{attrs:{"images":_vm.souvenirForm.images},on:{"image-added":_vm.addImage,"image-removed":_vm.removeImage}})],1),_vm._v(" "),_c('el-form-item',[(_vm.loadedForm)?_c('el-button',{on:{"click":_vm.cancel}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Cancel")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"id":"button-upload","type":"primary"},on:{"click":function($event){return _vm.submitForm('souvenirForm')}}},[(_vm.loadedForm)?_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Update")]):_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Upload")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nSBb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nxN4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.monument)?_c('div',{class:_vm.style,attrs:{"id":"monument-details"}},[_c('h2',[_vm._v(_vm._s(_vm.monument.name))]),_vm._v(" "),_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Rating")]),_vm._v(" "),_c('el-rate',{attrs:{"disabled":"","show-score":"","text-color":"#ff9900","score-template":_vm.points},model:{value:(_vm.monument.rating),callback:function ($$v) {_vm.$set(_vm.monument, "rating", $$v)},expression:"monument.rating"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-fa-image"}),_vm._v(" \n        "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Images")])]),_vm._v(" "),_c('el-carousel',{ref:"mainCarousel",staticClass:"image-container",attrs:{"trigger":"click","autoplay":false,"height":"50vh"},on:{"change":function (newIndex, oldIndex) { _vm.previewImageIndex = newIndex }}},_vm._l((_vm.monument.images),function(image){return _c('el-carousel-item',{key:image,staticClass:"image-container-item"},[_c('img',{attrs:{"src":image},on:{"click":function($event){_vm.isImagePreviewVisible=true}}})])}),1)],1),_vm._v(" "),_c('el-tab-pane',[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-fa-map-marker"}),_vm._v(" \n        "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Map")])]),_vm._v(" "),_c('map-view',{attrs:{"position":_vm.monument.position,"isEditable":false}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.monument.audio[_vm.$language.current])?_c('div',[_c('audio',{staticClass:"audio-player",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.monument.audio[_vm.$language.current],"type":"audio/mpeg"}})])]):_c('div',[_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Audio guide not available in the current language")]),_vm._v(" "),_vm._l((_vm.monument.audio),function(audio,key){return (audio)?_c('div',[_c('span',[_c('strong',[_c('translate',[_vm._v("Language")]),_vm._v(":")],1),_vm._v("\n        "+_vm._s(_vm.$language.available[key])+"\n      ")]),_vm._v(" "),_c('audio',{staticClass:"audio-player",attrs:{"controls":""}},[_c('source',{attrs:{"src":audio,"type":"audio/mpeg"}})])]):_vm._e()})],2),_vm._v(" "),_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-fa-info-circle"}),_vm._v(" \n        "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Details")])]),_vm._v(" "),_c('div',[_c('p',[_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Description")])]),_vm._v(" "),_c('p',{staticClass:"description-style"},[_vm._v(_vm._s(_vm.monument.description))]),_vm._v(" "),(_vm.monument.urls.length > 0)?_c('div',[_c('p',[_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("References")]),_c('br')]),_vm._v(" "),_vm._l((_vm.monument.urls),function(url){return _c('a',{attrs:{"href":url,"target":"_blank"}},[_vm._v(_vm._s(url)),_c('br')])})],2):_vm._e(),_vm._v(" "),_c('p',[_c('strong',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Created by")]),_vm._v(": "+_vm._s(_vm.monument.createdBy))])])]),_vm._v(" "),_c('el-tab-pane',[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-fa-comments"}),_vm._v(" \n        "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Comments")])]),_vm._v(" "),(_vm.monument.comments)?_c('div',[(_vm.monument.comments.length > 0)?_c('div',_vm._l((_vm.monument.comments),function(comment){return _c('el-card',{key:comment.id},[_c('div',{staticClass:"comment-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"comments-user-icon",style:({background: _vm.getColor(comment.createdBy)})},[_vm._v("\n                "+_vm._s(comment.createdBy[0].toUpperCase())+"\n              ")]),_vm._v(" "),_c('div',[_c('strong',{staticClass:"comment-title-content"},[_vm._v(_vm._s(comment.createdBy))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"comment-title-content"},[_vm._v(_vm._s(_vm.getDateTime(comment.date)))])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(comment.comment))])])}),1):_c('div',{staticClass:"center"},[_c('h3',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("There are no comments :(")])])]):_vm._e()])],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isImagePreviewVisible,"width":"95vw","top":"4vh"},on:{"update:visible":function($event){_vm.isImagePreviewVisible=$event}}},[(_vm.isImagePreviewVisible)?_c('el-carousel',{staticClass:"image-container",attrs:{"trigger":"click","initial-index":_vm.previewImageIndex,"autoplay":false,"height":"80vh"},on:{"change":function (newIndex, oldIndex) { _vm.$refs.mainCarousel.setActiveItem(newIndex) }}},_vm._l((_vm.monument.images),function(image){return _c('el-carousel-item',{key:image,staticClass:"image-container-item"},[_c('img',{attrs:{"src":image}})])}),1):_vm._e()],1),_vm._v(" "),(_vm.$session.exists() && _vm.$route.path !=='/')?_c('el-button',{attrs:{"size":"small","icon":"plus","type":"primary"},on:{"click":_vm.renderQrAgain}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Generate qr again")])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pTSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_md5__ = __webpack_require__("L6bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tourguide-navbar',
  computed: {
    avatarUrl: function avatarUrl() {
      return 'https://www.gravatar.com/avatar/' + __WEBPACK_IMPORTED_MODULE_0_md5___default()(this.$session.get('email').trim().toLowerCase());
    }
  }
});

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qPsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_md5__ = __webpack_require__("L6bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'update-profile',
  data: function data() {
    return {
      password: {
        visible: false,
        type: 'password',
        icon: 'el-icon-fa-eye',
        value: ''
      },
      userForm: {},
      rules: {
        firstName: {
          type: 'string',
          required: false
        },
        lastName: {
          type: 'string',
          required: false
        },
        password: [{
          type: 'string',
          required: false
        }, {
          min: 5,
          message: this.$gettext('Length should be min 5 characters'),
          trigger: 'blur'
        }],
        phoneNumber: [{
          type: 'string',
          required: false
        }, {
          validator: this.validatePhoneNumber,
          trigger: 'blur'
        }]
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$session.exists()) {
        next();
      } else {
        next('/signin');
      }
    });
  },
  created: function created() {
    this.getUserDetails();
  },

  methods: {
    validatePhoneNumber: function validatePhoneNumber(rule, value, callback) {
      if (value !== '') {
        var regex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
        if (regex.test(value)) {
          callback();
        } else {
          callback(new Error(this.$gettext('Phone number is not valid')));
        }
      } else {
        callback();
      }
    },
    avatarUrl: function avatarUrl() {
      return 'https://www.gravatar.com/avatar/' + __WEBPACK_IMPORTED_MODULE_1_md5___default()(this.$session.get('email').trim().toLowerCase()) + '?s=200';
    },
    showPassword: function showPassword() {
      if (!this.password.visible) {
        this.password.type = 'text';
        this.password.icon = 'el-icon-fa-eye-slash';
        this.password.visible = true;
      } else {
        this.password.type = 'password';
        this.password.icon = 'el-icon-fa-eye';
        this.password.visible = false;
      }
    },
    getUserDetails: function getUserDetails() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/' + this.$session.get('id'),
        withCredentials: true
      }).then(function (response) {
        _this.userForm = response.data;
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    uploadForm: function uploadForm() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/users/' + this.$session.get('id'),
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
        data: {
          firstName: this.userForm.firstName,
          lastName: this.userForm.lastName,
          password: this.password.value,
          phoneNumber: this.userForm.phoneNumber
        }
      }).then(function () {
        _this2.$message({
          type: 'success',
          message: _this2.$gettext('Update has completed')
        });
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$refs['userForm'].validate(function (valid) {
        if (valid) {
          _this3.uploadForm();
        }
      });
    },
    resetForm: function resetForm() {
      this.getUserDetails();
      this.password.value = '';
    }
  }
});

/***/ }),

/***/ "r3e2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBna":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTy2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w3r4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{attrs:{"name":"audio","with-credentials":true,"action":_vm.uploadUrl,"on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"limit":1,"on-exceed":_vm.handleExceed,"on-success":_vm.handleSuccess,"file-list":_vm.uploadedAudio,"accept":"audio/mpeg"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Upload")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.uploadTooltip))])],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isDialogVisible,"append-to-body":true},on:{"update:visible":function($event){_vm.isDialogVisible=$event}}},[(_vm.isDialogVisible)?_c('audio',{staticClass:"audio-player",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.dialogAudioUrl,"type":"audio/mpeg"}})]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wGsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reported_Comments_Newsfeed_vue__ = __webpack_require__("Mu8o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e709964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reported_Comments_Newsfeed_vue__ = __webpack_require__("MNvd");
function injectStyle (ssrContext) {
  __webpack_require__("3hxE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reported_Comments_Newsfeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e709964_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reported_Comments_Newsfeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Tourguide_Navbar_vue__ = __webpack_require__("jb7Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tourguide_Footer_vue__ = __webpack_require__("LBr5");
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'tourguide-navbar': __WEBPACK_IMPORTED_MODULE_1__components_Tourguide_Navbar_vue__["a" /* default */],
    'tourguide-footer': __WEBPACK_IMPORTED_MODULE_2__components_Tourguide_Footer_vue__["a" /* default */]
  },
  created: function created() {
    if (this.$localStorage.get('language')) {
      this.$language.current = this.$localStorage.get('language');
    } else {
      this.$localStorage.set('language', this.$language.current);
    }
    this.checkLogIn();
  },

  methods: {
    checkLogIn: function checkLogIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/auth/isLoggedIn',
        withCredentials: true
      }).then(function (response) {
        if (!_this.$session.exists()) {
          _this.$session.set('id', response.data.id);
          _this.$session.set('username', response.data.username);
          _this.$session.set('email', response.data.email);
          _this.$session.set('role', response.data.role);
          _this.$router.push('/monuments/list');
        }
      }).catch(function () {
        if (_this.$session.exists()) {
          _this.$session.destroy();
          window.location = '/';
        }
      });
    }
  }
});

/***/ }),

/***/ "yucd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Walk_Upload_Form_vue__ = __webpack_require__("AAmO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'walk-list',
  data: function data() {
    var menuItems = {
      images: 'images'
    };
    return {
      menuItems: menuItems,
      activeMenuImagesOrMap: menuItems.images,
      isEditVisible: false,
      walkList: [],
      currentPage: 1,
      pageSize: 10,
      walkListPage: []
    };
  },
  created: function created() {
    this.getWalkList();
  },

  components: {
    'walk-upload-form': __WEBPACK_IMPORTED_MODULE_1__Walk_Upload_Form_vue__["a" /* default */]
  },
  methods: {
    changePage: function changePage() {
      this.walkListPage = this.walkList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    getWalkList: function getWalkList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/walks?lang=' + this.$language.current,
        withCredentials: true
      }).then(function (response) {
        _this.walkList = response.data;
        _this.walkListPage = _this.walkList.slice((_this.currentPage - 1) * _this.pageSize, _this.currentPage * _this.pageSize);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    getWalk: function getWalk(id, callback) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/walks/' + id,
        withCredentials: true
      }).then(function (response) {
        _this2.walk = response.data;
        callback(null);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
        callback(error);
      });
    },
    handleClose: function handleClose(done) {
      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        done();
      }).catch(function () {});
    },
    edit: function edit(id) {
      var _this3 = this;

      this.getWalk(id, function (error) {
        if (!error) {
          _this3.isEditVisible = true;
        }
      });
    },
    closeEdit: function closeEdit() {
      this.isEditVisible = false;
      this.getWalkList();
    },
    remove: function remove(id) {
      var _this4 = this;

      this.$confirm(this.$gettext('Are you sure to delete the themed walk?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'delete',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/walks/' + id,
          withCredentials: true
        }).then(function () {
          _this4.$message({
            type: 'success',
            message: _this4.$gettext('Delete has completed')
          });
          _this4.getWalkList();
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this4.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: _this4.$gettext('Delete has canceled')
        });
      });
    }
  }
});

/***/ }),

/***/ "zCcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Partner_Companies_Upload_Form_vue__ = __webpack_require__("DUKa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'companies-list',
  data: function data() {
    var menuItems = {
      images: 'images'
    };
    return {
      menuItems: menuItems,
      activeMenuImagesOrMap: menuItems.images,
      isEditVisible: false,
      companiesList: [],
      currentPage: 1,
      pageSize: 10,
      companiesListPage: []
    };
  },
  created: function created() {
    this.getcompaniesList();
  },

  components: {
    'companies-upload-form': __WEBPACK_IMPORTED_MODULE_1__Partner_Companies_Upload_Form_vue__["a" /* default */]
  },
  methods: {
    changePage: function changePage() {
      this.companiesListPage = this.companiesList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    getcompaniesList: function getcompaniesList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/companies?lang=' + this.$language.current,
        withCredentials: true
      }).then(function (response) {
        _this.companiesList = response.data;
        _this.companiesListPage = _this.companiesList.slice((_this.currentPage - 1) * _this.pageSize, _this.currentPage * _this.pageSize);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    getCompanies: function getCompanies(id, callback) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: "https://tourinfo.pedu.codespring.ro:443/api" + '/companies/' + id,
        withCredentials: true
      }).then(function (response) {
        _this2.companies = response.data;
        callback(null);
      }).catch(function (error) {
        var msg;
        if (error.response) {
          msg = error.response.data || error.response.statusText;
        } else {
          msg = error.message;
        }
        _this2.$message({
          type: 'error',
          message: msg
        });
        callback(error);
      });
    },
    handleClose: function handleClose(done) {
      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        done();
      }).catch(function () {});
    },
    edit: function edit(id) {
      var _this3 = this;

      this.getCompanies(id, function (error) {
        if (!error) {
          _this3.isEditVisible = true;
        }
      });
    },
    closeEdit: function closeEdit() {
      this.isEditVisible = false;
      this.getcompaniesList();
    },
    remove: function remove(id) {
      var _this4 = this;

      this.$confirm(this.$gettext('Are you sure to delete the partner company?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'delete',
          url: "https://tourinfo.pedu.codespring.ro:443/api" + '/companies/' + id,
          withCredentials: true
        }).then(function () {
          _this4.$message({
            type: 'success',
            message: _this4.$gettext('Delete has completed')
          });
          _this4.getcompaniesList();
        }).catch(function (error) {
          var msg;
          if (error.response) {
            msg = error.response.data || error.response.statusText;
          } else {
            msg = error.message;
          }
          _this4.$message({
            type: 'error',
            message: msg
          });
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: _this4.$gettext('Delete has canceled')
        });
      });
    }
  }
});

/***/ }),

/***/ "zYn/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0504e02ecc943156ca01.js